/* eslint-disable camelcase */
/* eslint-disable func-names */
/* eslint-disable no-param-reassign */
/* eslint-disable eqeqeq */
/* eslint-disable no-restricted-syntax */
/* eslint-disable guard-for-in */
/* eslint-disable no-plusplus */
/* eslint-disable no-underscore-dangle */
/* eslint-disable prefer-rest-params */
/* eslint-disable no-useless-escape */
/* eslint-disable radix */
/* eslint-disable no-continue */
/* eslint-disable default-case */
/* eslint-disable consistent-return */
/* eslint-disable no-array-constructor */

import _ from 'lodash';
import has from 'lodash/has';

export const viewName = {
  SALE: 'sale',
  REFUND: 'refund',
  LAYAWAY: 'layaway',
  SPECIAL_ORDER: 'special_order',
  WORKORDER: 'workorder',
  EDIT_WORKORDER: 'edit_workorder',
  PAYMENTS: 'payments',
};

const registerRuleFailures = {
  AGE_VERIFICATION_REQUIRED: 'ageVerificationRequired',
  MIN_AGE: 'minAge',
};

/**
 * Document ready function to set auto focus on the page without affecting mobile
 * devices that are loading this page.
 */
$(function() {
  window.setAutoFocus();
});

export class Register implements MerchantosRegister {
  in_process: boolean;

  constructor() {
    this.in_process = false;
  }

  ensureAppIsDefined = () => {
    if (typeof window.App === 'undefined') {
      // This shouldn't be happening. Send out a log and reload the page
      // so we don't error out
      if (window.lsCloud && window.lsCloud.analytics) {
        window.lsCloud.analytics.track('Payment Service App Bug just happened');
      }
      window.location.reload();
    }
  };

  completeSale = () => {
    const content_map = {} as ContentMap;
    content_map.form_name = 'register.complete_transaction';

    this.gatherNoteShipToChanges(content_map);

    this.ensureAppIsDefined();
    window.showNotifier('working');

    const $finishSaleButton = $('#finishSaleButton');
    $finishSaleButton.prop('disabled', true);
    const completeSaleDeferred = $.Deferred();
    window.App.channel.reqres
      .request(window.App.globalEvents.register.PAYMENTS_FINISH)
      .done(() => {
        window.doServerCall(content_map, result => {
          completeSaleDeferred.resolve();
          this.completeSaleResult(result);

          // notify the API client to close the payments
          window.App.channel.vent.trigger(window.App.globalEvents.register.PAYMENTS_CLOSE);

          window.hideNotifier('working');
        });
      })
      .fail(() => {
        completeSaleDeferred.resolve();
        window.hideNotifier('working');
      })
      .always(() => {
        $finishSaleButton.prop('disabled', false);
      });

    return completeSaleDeferred.promise();
  };

  completeSaleResult = (result: AjaxFormsResponse) => {
    this.in_process = false;

    // todo make a purge credit card payments function for when things go wrong with the capture process
    if (result.remove_all_credit_cards) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'credit_card' does not exist on type 'Reg... Remove this comment to see the full error message
      this.credit_card.removeAllCreditCards();
    }
    if (result.purge_credit_cards) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'credit_card' does not exist on type 'Reg... Remove this comment to see the full error message
      this.credit_card.clearAll();
    }
    if (result.focus) {
      window.merchantos.focus.set(result.focus);
    }
    if (result.refocus) {
      window.merchantos.focus.set('cash_payment');
    }
    if (result.complete_failed) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Regist... Remove this comment to see the full error message
      this.payments.initialized = false;
      if (result.html) {
        window.merchantos.display.replaceNonAjax(result.html);
      } else {
        window.merchantos.utils.openUrl('/register.php');
      }
    } else if (result.html) {
      window.merchantos.display.replaceNonAjax(result.html);
      if (result.auto_print) {
        const openCashDrawer =
          typeof result.openCashDrawer === 'boolean' ? result.openCashDrawer : true;

        if (result.receiptPreference === 'printed') {
          window.merchantos.print.printUrl({
            url: result.auto_print,
            pageType: 'receipt',
            openCashDrawer,
          });
        } else {
          const noPopup = result.auto_print.replace(/print=1/g, 'print=0');
          window.merchantos.print.printUrl({
            url: noPopup,
            target: '_self',
            pageType: 'receipt',
            openCashDrawer,
          });
        }
      }

      // clear any credit card transactions
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Regist... Remove this comment to see the full error message
      this.payments.credit_cards = {};
    }
  };

  /**
   * Checks for credit card payments that do not have a credit charge ID (i.e. not
   * saved to the server) and prompts to continue if there are.
   *
   * @returns {boolean} Will be `true` if it's okay to continue.
   */
  confirmForUnsavedCreditPayments = () => {
    let confirmed = true;

    this.ensureAppIsDefined();
    if (has(window.App, 'client') && window.App.client.enabled) {
      // If the application is enabled but the user does not have enough rights,
      // Then App.client.enabled will not be defined, and this check would fail
      confirmed = window.App.channel.reqres.request('payments:sale:confirm:for:unsaved:changes');
    }

    return confirmed;
  };

  /**
   * Navigate to a view, but FIRST: Record the display (how things are shown and hidden)
   *
   * @param {string} view The view to navigate to
   */
  navigateToView = (view: string, id?: string) => {
    window.merchantos.display.init();
    window.merchantos.display.hideListingsViews();
    window.merchantos.display.recordDisplay();
    this.addRegisterParent();
    window.navigateToContent('view', view, id);
  };

  /**
   * The register needs special handling for breadcrumbs
   */
  addRegisterParent = () => {
    const parent_obj = {
      name: 'register',
      title: 'Current Sale',
      type: 'sale',
      id: 'sale',
    };

    window.breadcrumbs = [parent_obj];
    window.setCrumbs();
  };

  gatherNoteShipToChanges = (contentMap: ContentMap) => {
    // save customer note data
    const note_form = window.singleElementById('customer_note_data');
    if (note_form) {
      // see if it's visible
      const note_edit = window.singleElementById('note_edit');
      if (note_edit && note_edit.style.display !== 'none') {
        // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'HTMLElement' is not assignable t... Remove this comment to see the full error message
        // eslint-disable-next-line no-param-reassign
        contentMap.save_customer_note = window.toJsonString(window.getFormValues(note_form));
      }
    }

    // save customer ship to data
    const ship_to_form = window.singleElementById('ship_to_data');
    if (ship_to_form) {
      // see if it's visible
      const ship_edit = window.singleElementById('ship_edit');
      if (ship_edit && ship_edit.style.display !== 'none') {
        // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'HTMLElement' is not assignable t... Remove this comment to see the full error message
        // eslint-disable-next-line no-param-reassign
        contentMap.save_ship_to = window.toJsonString(window.getFormValues(ship_to_form));
      }
    }
  };

  /**
   * Add an item to the transaction
   *
   * @param {number} itemId The item id to add
   * @returns {boolean} Despite having async side-effects this will always return `true` synchronously.
   */
  addUserItem = (itemId: number) => {
    const content_map = {} as ContentMap;
    content_map.form_name = 'register.add_user_item';
    content_map.item_id = itemId;

    // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'result' implicitly has an 'any' type.
    const callback = result => {
      this.ajaxRegister_Return(result);

      // notify the API client that the sale has been updated
      this.ensureAppIsDefined();
      window.App.channel.vent.trigger(window.App.globalEvents.register.SALE_UPDATED);
    };

    window.doServerCall(content_map, callback).done(data => {
      this.validateRegisterRuleAgeVerification(data, content_map, callback);
      // clear the crumbs
      this.addRegisterParent();
    });
    return true;
  };

  /**
   * Add quote to the transaction
   *
   * @param {number} transactionId ID of the transaction to add the quote to.
   * @returns {boolean} Despite having async side-effects this will always return `true` synchronously.
   */
  addQuote = (transactionId: number) => {
    const content_map = {} as ContentMap;
    content_map.form_name = 'register.load_quote';
    content_map.transaction_id = transactionId;

    window.doServerCall(content_map, result => {
      this.ajaxRegister_Return(result);

      this.ensureAppIsDefined();
      window.App.navigateToRegisterUrl(window.App.currentUrl());
    });
    return true;
  };

  /**
   * Add multiple items to the transaction
   *
   * @param {string} itemIds Comma separated list of item_ids to add
   * @param {string} [quantities] Optional: Comma separated list of quantities to add, correlates with item_ids
   * @returns {boolean} Despite having async side-effects this will always return `true` synchronously.
   */
  addMultipleUserItems = (itemIds: string, quantities?: string) => {
    const content_map = {} as ContentMap;
    content_map.form_name = 'register.add_multiple_user_items';
    content_map.item_ids = itemIds;
    if (quantities) {
      content_map.quantities = quantities;
    }

    this.ensureAppIsDefined();

    // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'result' implicitly has an 'any' type.
    const callback = result => {
      this.ajaxRegister_Return(result);

      // notify the API client that the sale has been updated
      window.App.channel.vent.trigger(window.App.globalEvents.register.SALE_UPDATED);
    };

    window.doServerCall(content_map, callback).done(data => {
      this.validateRegisterRuleAgeVerification(data, content_map, callback);
    });
    return true;
  };

  addItemSearch = (input: HTMLInputElement, button?: HTMLButtonElement) => {
    const form_name = 'register.add_item_search';
    const content_map = {
      form_name,
      add_search_item_text: input.value,
    } as ContentMap;

    const promise = $.Deferred();

    this.ensureAppIsDefined();

    // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'result' implicitly has an 'any' type.
    const callback = result => {
      this.ajaxRegister_Return(result);

      // notify the API client that the sale has been updated
      window.App.channel.vent.trigger(window.App.globalEvents.register.SALE_UPDATED);
    };

    window
      .doServerCall(content_map, callback)
      .done(data => {
        this.validateRegisterRuleAgeVerification(data, content_map, callback);
      })
      .always(() => {
        promise.resolve();
      });

    // eslint-disable-next-line no-param-reassign
    input.value = '';

    // Track multiple clicks & visually disable button
    // @ts-expect-error ts-migrate(2722) FIXME: Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
    window.merchantos.sidebar.xhrStarted(form_name, button, promise);

    return true;
  };

  /**
   * Replacement function for adding an item search but does so in a way to
   * represent the scanned item as a placeholder in a table until the request comes back
   * Eventually this should replace the addItemSearch() function altogether.
   * @param {HTMLInputElement} input Input element containing search string
   * @param {HTMLButtonElement} [button] Button element for tracking
   * @returns {boolean} Despite having async side-effects this will always return `true` synchronously.
   */
  addItemSearchAdvanced = (input: HTMLInputElement, button?: HTMLButtonElement) => {
    const searchItemText = input.value;
    // Some item-searches get placeholders until the search request completes
    if (this.isAdvancedItemScan(searchItemText)) {
      const placeholderID = this.addOrUpdateItemPlaceholder(searchItemText);

      const form_name = 'register.add_multiple_item_searches';
      const content_map = {
        form_name,
        values: [searchItemText],
      } as ContentMap;

      this.ensureAppIsDefined();

      const callback = (result: AjaxFormsResponse) => {
        this.ajaxRegister_Return(result);

        // notify the API client that the sale has been updated
        window.App.channel.vent.trigger(window.App.globalEvents.register.SALE_UPDATED);
      };

      const promise = window
        .doServerCall(content_map, callback)
        .done(data => {
          this.validateRegisterRuleAgeVerification(data, content_map, callback);
        })
        .always(() => {
          // Pass or fail we remove the placeholders
          if (placeholderID) {
            this.removeOrUpdateItemPlaceholder(placeholderID);
          }
        });

      // eslint-disable-next-line no-param-reassign
      input.value = '';

      // Track multiple clicks & visually disable button
      // @ts-expect-error ts-migrate(2722) FIXME: Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
      window.merchantos.sidebar.xhrStarted(form_name, button, promise);

      return true;
    }
    return this.addItemSearch(input);
  };

  /**
   * Add a placeholder row item to the given table if one is not present. If it is then increment the quantity
   * the placeholder quantity. Placeholder row is added as first element in the table
   *
   * @param {string} [description] The item description, usually barcode number
   * @returns {string} The id of the element representing the placeholder row item
   */
  // eslint-disable-next-line consistent-return
  addOrUpdateItemPlaceholder = (description?: string) => {
    let id = '';
    if (!description) return id;
    // Get the target table to insert to
    const lines_table = $('.lines tbody')[0];

    if (lines_table) {
      id = `${lines_table.id}-scanned-item-placeholder-${description}`;

      const placeholder = window.singleElementById(id);
      if (placeholder) {
        this.incrementItemPlaceholderQuantity(placeholder);
      } else {
        const placeholderHTML = this.buildItemPlaceholder(id, description);
        $(lines_table).prepend(placeholderHTML);
      }
    }
  };

  isRegisterRuleAgeVerificationError = (data: RegisterRuleData) => {
    return !!(
      data &&
      data.metadata &&
      data.metadata.registerRuleFailure &&
      [registerRuleFailures.AGE_VERIFICATION_REQUIRED, registerRuleFailures.MIN_AGE].includes(
        data.metadata.registerRuleFailure
      )
    );
  };

  validateRegisterRuleAgeVerification = (
    data: RegisterRuleData,
    contentMap: ContentMap,
    callback: (...args: any[]) => void
  ) => {
    if (!this.isRegisterRuleAgeVerificationError(data)) return;

    if (window.location.pathname !== '/register.php') {
      window.setLinkTo('/register.php');
      $('a.back').hide();
      $('footer#sales-buttons')
        .find('.needs-sale-lines')
        .show();
    }

    if (data.metadata?.registerRuleFailure === registerRuleFailures.MIN_AGE) {
      window.initRegisterRulesModal({
        step: 'AgeVerificationError',
        stepData: {
          reason: 'MinAge',
        },
      });
    } else {
      const deferred = $.Deferred();

      window.initRegisterRulesModal({
        deferred,
        stepData: {
          requiredAge: data.metadata?.requiredAge,
        },
      });

      deferred.done(() => {
        // Re-do the action of adding the item(s) which was prevented by the register rule
        window.doServerCall(contentMap, callback).done(data => {
          this.validateRegisterRuleAgeVerification(data, contentMap, callback);
        });
      });

      deferred.fail(() => {
        window.alertUser(
          "Age-restricted items were not added to the sale because the customer's age cannot be verified."
        );
      });
    }
  };

  /**
   * Decrement the placeholder item's quantity. Once it becomes zero then remove it altogether.
   *
   * @param {string} id The id of placeholder row element
   */
  removeOrUpdateItemPlaceholder = (id: string) => {
    if (!id) return;
    const placeholder = window.singleElementById(id);
    if (!placeholder) return;
    const quantity = this.decrementItemPlaceholderQuantity(placeholder);
    if (!isNaN(quantity) && quantity <= 0) {
      $(placeholder).remove();
    }
  };

  /**
   * Remove all of the lines on the transaction
   */
  deleteAll = () => {
    const content_map = { form_name: 'register.delete_all' } as ContentMap;

    this.ensureAppIsDefined();

    window.doServerCall(content_map, result => {
      this.ajaxRegister_Return(result);

      // notify the API client that the sale has been updated
      window.App.channel.vent.trigger(window.App.globalEvents.register.SALE_UPDATED);
    });
  };

  /**
   * Determines whether the register is to display placeholder for given search description to represent the item while waiting.
   * Placeholders are only currently supported for 7 or 11-13 digit barcodes
   *
   * @param {string} searchItemText The item search string
   * @return {boolean} `true` if a placeholder is to be used to represent the item while we're waiting
   * for search request, `false` otherwise.
   */
  isAdvancedItemScan = (searchItemText: string) => {
    // any 11-13 digit code that doesn't start with 2 or 4
    const vanilla_barcode = /^(?!2|4)[0-9]{11,13}$/;

    // any 7,8 digit short code
    const short_barcode = /^[0-9]{7,8}$/;

    // item scan that starts with 21
    const merchantos_item_barcode = /^21[0-9]{10,11}$/;

    return (
      vanilla_barcode.test(searchItemText) ||
      short_barcode.test(searchItemText) ||
      merchantos_item_barcode.test(searchItemText)
    );
  };

  /**
   * Build and return html for an item's placeholder row
   *
   * @param {string} id the id of the placeholder root node
   * @param {string} description the item placeholder description
   * @return {string} html fragment that represents the item placeholder
   */
  buildItemPlaceholder = (id: string, description: string) => {
    let placeholderHTML = `<tr id="${id}" class="pending">`;
    placeholderHTML += '<td><i class="icon-refresh icon-spin"></i></td>';
    placeholderHTML += `<td colspan="2"><span class="status-block">Pending</span>${description}</td>`;
    placeholderHTML += '<td class="item-placeholder-quantity">1</td>';
    placeholderHTML += '<td colspan="2"></td>';
    placeholderHTML += '</tr>';
    return placeholderHTML;
  };

  /**
   * Bump up the quantity value for the given item placeholder by 1.
   *
   * @param {HTMLElement} placeholderRow DOM node
   * @returns {number} The resulting quantity
   */
  incrementItemPlaceholderQuantity = (placeholderRow: HTMLElement) => {
    return this.adjustItemPlaceholderQuantity(placeholderRow, 1);
  };

  /**
   * Decrement the quantity value for the given item placeholder by 1.
   *
   * @param {HTMLElement} placeholderRow DOM node
   * @returns {number} The resulting quantity
   */
  decrementItemPlaceholderQuantity = (placeholderRow: HTMLElement) => {
    return this.adjustItemPlaceholderQuantity(placeholderRow, -1);
  };

  /**
   * Adjust the quantity value of the given item placeholder row by the specified amount
   *
   * @param {element} placeholderRow The item placeholder dom node
   * @param {number} delta The delta to adjust the quantity, can be negative
   * @return {number} The resulting quantity value, NaN if there was an error
   */
  adjustItemPlaceholderQuantity = (placeholderRow: HTMLElement, delta: number) => {
    let quantity = NaN;
    const quantityCell = $(placeholderRow).find('td.item-placeholder-quantity');
    if (quantityCell && window.isNumber(delta)) {
      quantity = parseInt(quantityCell.text(), 10);
      if (!isNaN(quantity)) {
        quantity += delta;
        quantityCell.text(quantity);
      }
    }
    return quantity;
  };

  /**
   * Enable/disable the payment buttons
   *
   * @param {boolean} isEnabled `true to` enable them, `false` to disable
   */
  enablePaymentButtons = (isEnabled: boolean) => {
    $('#paymentButton').prop('disabled', !isEnabled);
    $('#cancelButton').prop('disabled', !isEnabled);
    $('#saveAsQuoteButton').prop('disabled', !isEnabled);
  };

  setLineDeposit = (amount: number, lineId: number) => {
    const content_map = {} as ContentMap;
    content_map.form_name = 'register.generic';
    content_map.register_form = 'set_line_deposit';
    content_map.transaction_line_id = lineId;
    content_map.amount = amount;
    window.doServerCall(content_map, result => {
      this.ajaxRegister_Return(result);
    });
    return true;
  };

  donePay = () => {
    if (this.in_process) {
      return false;
    }

    // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Regist... Remove this comment to see the full error message
    this.payments.initialized = false;
    const content_map = {} as ContentMap;
    content_map.form_name = 'register.generic';
    content_map.register_form = 'do_payments';

    this.gatherNoteShipToChanges(content_map);

    window.doServerCall(content_map, result => {
      this.ajaxRegister_Return(result);

      this.ensureAppIsDefined();
      // notify the API client that payments are finished
      window.App.channel.vent.trigger(window.App.globalEvents.register.PAYMENTS_START);
    });

    return true;
  };

  continueSale = () => {
    if (this.in_process) {
      return false;
    }

    this.ensureAppIsDefined();
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'partial_payments' does not exist on type... Remove this comment to see the full error message
    this.partial_payments.forceCancel();

    const content_map = {} as ContentMap;
    content_map.form_name = 'register.generic';
    content_map.register_form = 'continue_sale';

    this.gatherNoteShipToChanges(content_map);

    return window.doServerCall(content_map, result => {
      this.ajaxRegister_Return(result);

      // notify the API client to close the payments
      window.App.channel.vent.trigger(window.App.globalEvents.register.PAYMENTS_CLOSE);
    });
  };

  saveQuote = () => {
    const content_map = {
      form_name: 'register.generic',
      register_form: 'invoice',
      get_receipt: true,
    } as ContentMap;

    window.doServerCall(content_map, result => {
      if (!result.html) return;
      window.merchantos.display.replaceNonAjax(result.html);

      if (!result.receipt_url) return;
      window.merchantos.print.printUrl({ url: result.receipt_url, pageType: 'receipt' });
    });
  };

  changeView = (view: any) => {
    window.clearParents();
    const content_map = {} as ContentMap;
    content_map.form_name = 'register.generic';
    content_map.register_form = 'change_view';
    content_map.view = view;

    this.gatherNoteShipToChanges(content_map);

    window.doServerCall(content_map, result => {
      this.ajaxRegister_Return(result);
    });
    return true;
  };

  /**
   * Open a URL with sale parameters filled, hits a script that redirects to URL with parameters filled.
   *
   * @param {string} url The URL to open (parameters will be appended)
   * @param {string} target The target (e.g. '_blank')
   *
   * @return {boolean}
   */
  openURL = (url: string, target: string) => {
    const newURL = `/register.php?form_name=open_url&url=${encodeURIComponent(url)}`;

    window.merchantos.utils.openUrl(newURL, target);
  };

  /**
   * Edit a transaction line - the old way. I think this is now unused - justin 9/20/09 inlineEditLine is the new way
   *
   * @param {string} lineId The line to edit
   * @return {boolean}
   */
  editLine = (lineId: string) => {
    const content_map = {} as ContentMap;
    content_map.form_name = 'register.edit_transaction_line';
    content_map.transaction_line_id = lineId;
    window.doServerCall(content_map, result => {
      this.ajaxRegister_Return(result);
    });
    return true;
  };

  editCustomerNote = () => {
    const content_map = {} as ContentMap;
    content_map.form_name = 'register.get_customer_note';
    window.doServerCall(content_map, result => {
      this.ajaxRegister_Return(result);
      this.ensureAppIsDefined();
      window.App.channel.vent.trigger(window.App.globalEvents.register.SHOW_PAYMENTS);
    });
    return true;
  };

  saveCustomerNoteShipTo = () => {
    const content_map = {} as ContentMap;
    content_map.form_name = 'register.generic';

    this.gatherNoteShipToChanges(content_map);
    window.showNotifier('working');

    window.doServerCall(content_map, result => {
      this.ajaxRegister_Return(result);
      this.ensureAppIsDefined();
      // Failsafe check in case reqres or the event was not yet registred (fast clicking before dom is ready)
      if (
        window.App.channel.reqres &&
        window.App.channel.reqres.hasHandler(window.App.globalEvents.register.SHIPPING_UPDATED)
      ) {
        window.App.channel.reqres
          .request(window.App.globalEvents.register.SHIPPING_UPDATED)
          .done(() => {
            window.App.channel.vent.trigger(window.App.globalEvents.register.SHOW_PAYMENTS);
          })
          .always(() => {
            window.hideNotifier('working');
          });
      } else {
        window.hideNotifier('working');
      }
    });
    return true;
  };

  closeWorkorder = () => {
    const content_map = {} as ContentMap;
    content_map.form_name = 'register.generic';
    content_map.register_form = 'close_workorder_edit';

    window.doServerCall(content_map, result => {
      this.ajaxRegister_Return(result);

      this.ensureAppIsDefined();
      window.App.channel.vent.trigger(window.App.globalEvents.register.SHOW_PAYMENTS);
    });
    return true;
  };

  /**
   * Opens an inline form below the register control bar to fill in details for adding different line types
   *
   * @param {string} type The type/name of the form to get
   * @return {boolean}
   */
  getAddExpander = (type: string) => {
    const content_map = {} as ContentMap;
    content_map.form_name = `register.add_expander.${type}`;

    window.doServerCall(content_map, result => {
      this.ajaxRegister_Return(result);
    });
    return true;
  };

  /**
   * Submit inline form for processing
   *
   * @param {string} type The type/name of the form to get
   * @param {object} obj
   * @return {boolean} `false`
   */
  submitAddExpander = (type: string, obj: Control) => {
    if (this.validateSaveAddExpander(type)) {
      if (!window.merchantos.controls.prevent_repeat.preventIt(obj)) {
        window.hideNotifier('warning'); // clear previous warning if visible
        this.saveAddExpander(type);
      }
    }
    return false;
  };

  /**
   * Save the inline form that expands below the control bar - adds a line to the sale/customer with specified details
   *
   * @param {string} type The type/name of the form to get
   * @return {boolean} `true`
   */
  saveAddExpander = (type: string) => {
    const add_expander = window.singleElementById('add_expander_holder');
    if (add_expander) {
      const content_map = {} as ContentMap;
      content_map.form_name = `register.add_expander.save_${type}`;
      content_map.values = window.toJsonString(window.getFormValues('add_expander'));

      this.ensureAppIsDefined();

      window.doServerCall(content_map, result => {
        this.ajaxRegister_Return(result);

        // notify the API client that the sale has been updated
        window.App.channel.vent.trigger(window.App.globalEvents.register.SALE_UPDATED);
      });
    }
    return true;
  };

  /**
   * this.saveAddExpander data validation
   *
   * @param {string} type The type/name of the form to validate
   * @return {boolean}
   */
  validateSaveAddExpander = (type: string) => {
    const content_map = {
      values: window.getFormValues('add_expander'),
    } as ContentMap;

    let msg = '';
    switch (type) {
      case 'add_labor':
        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        if (window.merchantos.form_validation.isEmpty(content_map.values.note)) {
          msg = 'Labor description can not be empty.';
          $('#add_labor_description').trigger('focus');
        }
        break;
      case 'add_misc':
        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        if (window.merchantos.form_validation.isEmpty(content_map.values.note)) {
          msg = 'Miscellaneous charge description can not be empty.';
          $('#add_misc_description').trigger('focus');
        }
        break;
      default:
        break;
    }

    if (msg) {
      window.showNotifier('warning', msg);
      return false;
    }
    return true;
  };

  /**
   * Opens an inline form below the sales/refund/layaway/special order line to edit that line's info
   *
   * @param {string} type The type/name of the form to get
   * @param {number} id The id of the record for the line
   * @param {number} lineId The id of line html
   * @param {string} focusElementId DOM id of the price input to set focus on
   * @return {boolean}
   */
  inlineEditLine = (type: string, id: number, lineId: number, focusElementId?: string) => {
    const content_map = {} as ContentMap;
    content_map.form_name = `register.inline_edit.${type}`;
    content_map.id = id;
    content_map.line_id = lineId;
    if (focusElementId) {
      content_map.set_focus = focusElementId;
    }

    this.ensureAppIsDefined();

    window.doServerCall(content_map, result => {
      this.ajaxRegister_Return(result);

      // notify the API client that the sale has been updated
      window.App.channel.vent.trigger(window.App.globalEvents.register.SALE_UPDATED);
    });

    return true;
  };

  /**
   * Submit inline form for processing.
   *
   * @param {object} obj The button object
   * @param {string} type process name
   * @param {number} id The id of the object that is being saved
   * @param {number} lineId The id of the transaction_line we are editing
   * @param {number} itemId The id of the item
   */
  submitInlineEditLine = (
    obj: Control,
    type: string,
    id: number,
    lineId: number,
    itemId: number
  ) => {
    if (itemId > 0 || (!itemId && this.validateInLineEditLine(type, id))) {
      if (!window.merchantos.controls.prevent_repeat.preventIt(obj)) {
        this.saveInlineEditLine(type, id, lineId);
      }
    }
  };

  /**
   * Validate for Misc and Labor charge, the note is not blank
   *
   * @param {string} type process name
   * @param {number} id The id of the object that is being saved
   * @returns {boolean} `true` if note present / `false` if note blank
   */
  validateInLineEditLine = (type: string, id: number) => {
    const content_map = {} as ContentMap;
    content_map.values = window.getFormValues(`${type}_${id}`);

    // @ts-expect-error ts-migrate(2339) FIXME: Property 'edit_item_note' does not exist on type '... Remove this comment to see the full error message
    if (window.merchantos.form_validation.isEmpty(content_map.values.edit_item_note)) {
      window.showNotifier('warning', 'Description can not be empty.');
      $(`#inline_edit_note_${id}`).trigger('focus');
      return false;
    }
    return true;
  };

  /**
   * Save the inline form to edit the sales/refund/layaway/special order line
   *
   * @param {string} type The type/name of the form to save
   * @param {number} id The id of the object that is being saved
   * @param {number} lineId The id of the transaction_line we are editing (same as id except for edit workorder stuff)
   * @return {boolean} `true`
   */
  saveInlineEditLine = (type: string, id: number, lineId: number) => {
    const inline_edit_form = window.singleElementById(`${type}_${id}`);
    if (inline_edit_form) {
      const content_map = {} as ContentMap;
      content_map.form_name = `register.inline_edit.save_${type}`;
      content_map.id = id;
      content_map.line_id = lineId;
      content_map.values = window.getFormValues(`${type}_${id}`);

      const $priceInput = $(`#edit_item_price_${id}`);
      if (
        (content_map.values as { [key: string]: string }).edit_item_price &&
        this.isAdvancedItemScan((content_map.values as { [key: string]: string }).edit_item_price)
      ) {
        $priceInput.addClass('error');
        $priceInput.val('');
        return false;
      }
      $priceInput.removeClass('error');

      content_map.values = window.toJsonString(content_map.values);

      this.ensureAppIsDefined();

      window.doServerCall(content_map, result => {
        this.ajaxRegister_Return(result);

        // notify the API client that the sale has been updated
        window.App.channel.vent.trigger(window.App.globalEvents.register.SALE_UPDATED);
      });
    }
    return true;
  };

  /**
   * Cancel the inline form to edit the sales/refund/layaway/special order line, restore the normal line
   *
   * @param {number} lineId The id of the transaction_line that is being edited
   * @return {boolean} `true`
   */
  cancelInlineEditLine = (lineId: number) => {
    $(`#line_${lineId}_1`).show();
    $(`#line_${lineId}_2`).show();
    $(`#line_${lineId}_3`).show();
    $(`#line_${lineId}_4`).show();
    $(`#line_${lineId}_5`).show();
    $(`#line_${lineId}_edit`).hide();
    return true;
  };

  /**
   * Delete a line from a transaction, customer
   *
   * @param {number} lineId The ID of the transaction_line to remove
   * @param {boolean} [canConfirm] - Optional whether or not to confirm deletion with user.
   * @param {string} [confirmationMessage] - Optional confirmation message to use
   * @return {boolean} `true`
   */
  removeLine = (lineId: number, canConfirm?: boolean, confirmationMessage?: string) => {
    let confirm_answer = true;
    if (canConfirm) {
      // eslint-disable-next-line no-param-reassign
      confirmationMessage =
        confirmationMessage ||
        'Are you sure you want to delete this line?  \n\nThis action cannot be undone.';
      // eslint-disable-next-line no-alert
      confirm_answer = window.confirm(confirmationMessage);
    }

    if (!confirm_answer) {
      return;
    }
    // if the line exists remove it
    this.remove_line_html(lineId);

    const numLines = $('[id^="line_"]').length;
    if (numLines < 1) {
      $('footer#sales-buttons')
        .find('.needs-sale-lines')
        .hide();
    }

    const content_map = {} as ContentMap;
    content_map.form_name = 'register.remove_line';
    content_map.transaction_line_id = lineId;

    this.ensureAppIsDefined();

    window.doServerCall(content_map, result => {
      this.ajaxRegister_Return(result);

      // notify the API client that the sale has been updated
      window.App.channel.vent.trigger(window.App.globalEvents.register.SALE_UPDATED);
    });
  };

  /**
   * Internally used to remove the actual HTML for a transaction line
   *
   * @param {number} lineId The ID of the transaction_line to remove
   * @return {boolean} `true`
   */
  remove_line_html = (lineId: number) => {
    $(`#line_${lineId}_1`).remove();
    $(`#line_${lineId}_2`).remove();
    $(`#line_${lineId}_3`).remove();
    $(`#line_${lineId}_4`).remove();
    $(`#line_${lineId}_5`).remove();
    $(`#line_${lineId}_edit`).remove();
  };

  /**
   * Internally used to add or replace the HTML of a line item
   *
   * @param {HTMLElement} table The DOM Node that is table or tbody that the add/replace will be done on
   * @param {number} lineId The ID of the transaction_line to remove
   * @param {string} newHTML The HTML to use as the new line
   */
  add_or_replace_line_html = (table: HTMLElement, lineId: number, newHTML: string) => {
    // If the item has no description, it shouldn't be a line at all
    const description = $<HTMLAnchorElement>(newHTML).find('td.register-lines-control a')[0].text;
    if (!description) {
      const lines = $(`tr[id^=line_${lineId}]`);
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < lines.length; i++) {
        lines[i].remove();
      }
      return;
    }

    const innerhtml_table = document.createElement('table');
    innerhtml_table.innerHTML = newHTML;

    const fragment = document.createDocumentFragment();

    let innerhtml_tbody: ChildNode | undefined;
    let child;
    // eslint-disable-next-line no-plusplus
    for (let y = 0; y < innerhtml_table.childNodes.length; y++) {
      child = innerhtml_table.childNodes[y];
      if (child.nodeName.toLowerCase() === 'tbody') {
        innerhtml_tbody = child;
      }
    }
    if (!innerhtml_tbody) {
      // this is for safari and any other browser that doesn't create a tbody within the table automatically
      innerhtml_tbody = innerhtml_table;
    }

    // eslint-disable-next-line no-plusplus
    for (let x = 0; x < innerhtml_tbody.childNodes.length; x++) {
      child = innerhtml_tbody.childNodes[x];
      if (child.nodeName.toLowerCase() !== 'tr') {
        // eslint-disable-next-line no-continue
        continue;
      }
      innerhtml_tbody.removeChild(child);
      fragment.appendChild(child);
    }

    let replace_done = false;

    const existing_line1 = window.singleElementById(`line_${lineId}_1`);
    const existing_line2 = window.singleElementById(`line_${lineId}_2`);
    const existing_line3 = window.singleElementById(`line_${lineId}_3`);
    const existing_line4 = window.singleElementById(`line_${lineId}_4`);
    const existing_line5 = window.singleElementById(`line_${lineId}_5`);
    const existing_line_edit = window.singleElementById(`line_${lineId}_edit`);
    if (existing_line3) {
      existing_line3.parentNode?.replaceChild(fragment, existing_line3);
      replace_done = true;
    }
    if (existing_line1) {
      if (replace_done) {
        existing_line1.parentNode?.removeChild(existing_line1);
      } else {
        existing_line1.parentNode?.replaceChild(fragment, existing_line1);
        replace_done = true;
      }
    }
    if (existing_line2) {
      if (replace_done) {
        existing_line2.parentNode?.removeChild(existing_line2);
      } else {
        existing_line2.parentNode?.replaceChild(fragment, existing_line2);
        replace_done = true;
      }
    }
    if (existing_line4) {
      if (replace_done) {
        existing_line4.parentNode?.removeChild(existing_line4);
      } else {
        existing_line4.parentNode?.replaceChild(fragment, existing_line4);
        replace_done = true;
      }
    }
    if (existing_line5) {
      if (replace_done) {
        existing_line5.parentNode?.removeChild(existing_line5);
      } else {
        existing_line5.parentNode?.replaceChild(fragment, existing_line5);
        replace_done = true;
      }
    }
    if (existing_line_edit) {
      if (replace_done) {
        existing_line_edit.parentNode?.removeChild(existing_line_edit);
      } else {
        existing_line_edit.parentNode?.replaceChild(fragment, existing_line_edit);
        replace_done = true;
      }
    }

    if (!replace_done) {
      // not found we need to add it
      if (table.firstChild) {
        table.insertBefore(fragment, table.firstChild);
        return;
      }
      table.appendChild(fragment);
    }
  };

  /**
   * Save edits done directly on the sale line editable fields
   *
   * @param {string} type The form processor handler to use to save the edit (in includes/forms/ajax_forms/direct_edit/save_<type>.php)
   * @param {string} field The name of the field on the line that is being edited (field should be in the form of "<tablename>.<fieldname>")
   * @param {number} id The id of the object that is being edited
   * @param {number} lineId The id of the transaction_line that is being edited (same as id param except for edit_workorder stuff)
   * @param {mixed} newValue The new value to save in the object field
   * @returns {void} Despite having async side-effects this will always return `undefined` synchronously
   */
  saveDirectEdit = (type: string, field: string, id: number, lineId: number, newValue: any) => {
    this.in_process = true;

    const content_map = {} as ContentMap;
    content_map.form_name = `register.direct_edit.save_${type}`;
    content_map.field = field;
    content_map.id = id;
    content_map.line_id = lineId;
    content_map.new_value = newValue;

    this.ensureAppIsDefined();
    window.App.channel.vent.trigger(window.App.globalEvents.register.SALE_UPDATING);

    window.doServerCall(content_map, result => {
      this.ajaxRegister_Return_saveDirectEdit(result);

      // notify the API client that the sale has been updated
      window.App.channel.vent.trigger(window.App.globalEvents.register.SALE_UPDATED);
    });
  };

  /**
   * a wrapper for the return of the saveDirectEdit server call so we can unblock stuff
   *
   * @param {AjaxFormsResponse} result the result of the server call
   * @return {JQuery.Promise}
   */
  // @ts-expect-error ts-migrate(2416) FIXME: Property 'ajaxRegister_Return_saveDirectEdit' in t... Remove this comment to see the full error message
  ajaxRegister_Return_saveDirectEdit = (result: AjaxFormsResponse) => {
    this.in_process = false;
    return this.ajaxRegister_Return(result);
  };

  /**
   * Function called by .bind after ajax response is received
   *
   * @param {AjaxFormsResponse} result the result of the server call
   */
  // @ts-expect-error ts-migrate(2416) FIXME: Property 'ajaxRegister_Return' in type 'Register' ... Remove this comment to see the full error message
  ajaxRegister_Return = (result: AjaxFormsResponse) => {
    let lines_table;
    let promise: JQuery.Promise<any> | JQuery.Deferred<any>;

    if (result.html) {
      if (result.replace_lines) {
        // display content that replace the man sales lines (and other tabs) part of the register, leaves the customer name and totals
        // like the item edit dialog would do this
        // todo add an id to that part of the HTML so it can be replaced
      } else {
        window.merchantos.display.replaceNonAjax(result.html);
      }

      if (result.set_focus) {
        window.merchantos.focus.set(result.set_focus);
      }
    }

    if (result.close_add_expander) {
      $('#add_expander_holder').hide();
    }

    if (result.customer_note) {
      const note_edit = window.singleElementById('note_edit');
      const note_edit_field = window.singleElementById('note_edit_field');
      if (note_edit && note_edit_field) {
        // hide the note summary row
        $('#customer_note_row').hide();

        $(note_edit).show();
        $(note_edit_field).htmlReplace(result.note_text);
      }
    }
    if (result.add_expander) {
      $('#add_expander_holder')
        .show()
        .htmlReplace(result.add_expander);
      if (result.set_focus) {
        window.merchantos.focus.set(result.set_focus);
      }
    }
    if (result.inline_edit) {
      const existing_line_edit = $(`#line_${result.line_id}_edit`);
      const existing_line_edit_inner = $(`#line_${result.line_id}_edit_inner`);
      if (existing_line_edit && existing_line_edit_inner) {
        existing_line_edit.show();
        existing_line_edit_inner.htmlReplace(result.inline_edit);

        $(`#line_${result.line_id}_1`).hide();
        $(`#line_${result.line_id}_2`).hide();
        $(`#line_${result.line_id}_3`).hide();
        $(`#line_${result.line_id}_4`).hide();
        $(`#line_${result.line_id}_5`).hide();

        if (result.set_focus) {
          window.merchantos.focus.set(result.set_focus);
        }
      }
    }
    if (result.remove_line) {
      this.remove_line_html(result.line_id!);
    }
    if (result.add_line) {
      // get the lines table
      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string | undefined' is not assig... Remove this comment to see the full error message
      lines_table = window.singleElementById(result.line_type);
      if (!lines_table) {
        window.merchantos.utils.openUrl('/register.php');
        return;
      }
      // add the line or replace it
      // TODO: update this function
      this.add_or_replace_line_html(lines_table, result.line_id!, result.add_line_html!);

      // enable the all lines buttons
      $('#all_lines_functions').show();

      // Do not set focus if it already has it. We could be interrupting scanner input by doing so...
      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string | undefined' is not assig... Remove this comment to see the full error message
      const focusElement = window.singleElementById(result.set_focus);
      if (result.set_focus && !$(focusElement || {}).is(':focus')) {
        window.merchantos.focus.set(result.set_focus);
      }

      window.setLinkTo('/register.php');
      $('a.back').hide();
      $('footer#sales-buttons')
        .find('.needs-sale-lines')
        .show();
    }
    if (result.add_multiple_lines) {
      // get the lines table
      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string | undefined' is not assig... Remove this comment to see the full error message
      lines_table = window.singleElementById(result.line_type);
      if (!lines_table) {
        window.merchantos.utils.openUrl(window.location.href);
        return;
      }

      if (result.update_all_lines) {
        while (lines_table.lastElementChild) {
          lines_table.removeChild(lines_table.lastElementChild);
        }
      }

      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < result.lines!.length; i++) {
        const line = result.lines![i];
        const isLast = i === result.lines!.length - 1;
        // if the line exists remove it
        this.remove_line_html(line.line_id);
        // add the line
        // NOTE: prepended, so lines item will be listed in reverted order. Does
        // not make sense but didn't want to change the current behaviour for clients.
        lines_table.innerHTML = line.add_line_html + lines_table.innerHTML;

        if (line.edit_line) {
          this.inlineEditLine(
            'transaction_line', // Form type
            line.edit_line_id, // ID for record associated with the line
            line.edit_line_line_id, // ID for the line itself
            isLast ? `edit_item_price_${line.edit_line_line_id}` : undefined // Focus target
          );
        }
      }

      // enable the all lines buttons
      $('#all_lines_functions').show();

      // Do not set focus if it already has it. We could be interrupting scanner input by doing so...
      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string | undefined' is not assig... Remove this comment to see the full error message
      const focusElement = window.singleElementById(result.set_focus);
      if (result.set_focus && !$(focusElement || {}).is(':focus')) {
        window.merchantos.focus.set(result.set_focus);
      }

      window.setLinkTo('/register.php');
      $('a.back').hide();
      $('footer#sales-buttons')
        .find('.needs-sale-lines')
        .show();
    }
    if (result.load_refund) {
      window.setLinkTo('/register.php');
      $('a.back').hide();
      $('footer#sales-buttons')
        .find('.needs-sale-lines')
        .show();
    }
    if (result.totals_html) {
      // replace the totals
      const totals = $('#register_totals');
      if (totals) {
        totals.htmlReplace(result.totals_html);
      }
    }
    if (result.special_total) {
      // replace any special totals
      $(`#${result.special_total}`).htmlReplace(result.special_total_html!);
    }
    if (result.listing) {
      promise = this.navigateToListing(
        result.listing,
        result.search_description!,
        result.results_tab!
      );
    } else {
      promise = $.Deferred()
        .resolve()
        .promise();
    }

    // see if we need to edit a line price
    if (result.edit_line) {
      this.inlineEditLine(
        'transaction_line',
        result.edit_line_id!,
        result.edit_line_line_id!,
        `edit_item_price_${result.edit_line_line_id}`
      );
    }

    if (result.view) {
      let title: string | undefined;
      // The switch statement below has only two breaks: One at EDIT_WORKORDER and PAYMENTS.
      // This means that if the code is at the viewName.Sale block, it will keep going until it sees a break.
      // Look at https://jira.atlightspeed.net/browse/CLD-35553 for more information on why we did this
      /* eslint-disable no-fallthrough, no-unneeded-ternary */
      switch (result.view) {
        case viewName.SALE:
          title = 'Sale';
        case viewName.REFUND:
          title = title ? title : 'Refund';
        case viewName.LAYAWAY:
          title = title ? title : 'Layaway';
        case viewName.SPECIAL_ORDER:
          title = title ? title : 'Special Order';
        case viewName.WORKORDER:
          title = title ? title : 'Work Orders';
        case viewName.EDIT_WORKORDER:
          title = title ? title : 'Edit Work Order';

          window.setLinkTo(`/register.php?form_name=change_view&view=${result.view}`);
          break;
        case viewName.PAYMENTS:
          window.setLinkTo('/register.php?form_name=do_payments', 'Payment');
          break;
        default: {
          // swallow default
        }
      }
      /* eslint-enable no-fallthrough, no-unneeded-ternary */
    }

    // This is to force iOS to do a re-draw of everything after we're
    // done, since it doesn't always do one when the keyboard closes
    if (navigator.userAgent.match(/(iPhone|iPod|iPad)/i)) {
      $('body').css('-webkit-transform', 'translate3d(0,0,0)');
    }

    // eslint-disable-next-line consistent-return
    return promise;
  };

  /**
   * Display a listing view
   * @param {string} listing the name of the listing to display
   * @param {string} search_description the description to search and show listings for
   * @param {string} results_tab id of the tab to display the results.
   * @return {$.Deferred}
   */
  // @ts-expect-error ts-migrate(2416) FIXME: Property 'navigateToListing' in type 'Register' is... Remove this comment to see the full error message
  navigateToListing = (listing: string, searchDescription: string, resultsTab: string) => {
    window.merchantos.display.init();
    window.merchantos.display.hideListingsViews();
    window.merchantos.display.recordDisplay();

    window.merchantos.focus.record('add_search_item_text');
    const initSearch = [['description', searchDescription]];

    this.addRegisterParent();
    return window.navigateToContent('listing', listing, initSearch, resultsTab);
  };

  inputBlur = () => {
    if (window.isMobileDevice()) {
      return;
    }

    const switchFocusFromBody = () => {
      if ($(document.activeElement as HTMLElement).is('body')) {
        $('.itembarcode').trigger('focus');
      }
    };

    // The switchFocusFromBody function uses docoument.activeElement which is
    // not accurate while blur event is processing. Delaying one tick
    // allows the blur event to finish so that activeElement is correct.
    setTimeout(switchFocusFromBody, 1);
  };

  inputKeyPress = (event: KeyboardEvent) => {
    if (event.keyCode === 13) {
      $('.itembarcode').trigger('focus');
    }
  };
}

// @ts-expect-error ts-migrate(2741) FIXME: Property 'terminal_payment' is missing in type 'Re... Remove this comment to see the full error message
window.merchantos.register = new Register();

// @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
window.merchantos.register.payments = new (function() {
  // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
  this.list = {};
  // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
  this.cash = 0.0;
  // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
  this.change = 0.0;
  // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
  this.credit_charge = 0.0;
  // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
  this.credit_deposit = 0.0;
  // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
  this.credit_deposit_type = 0;
  // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
  this.credit_withdraws = {};
  // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
  this.gift_cards = {};
  // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
  this.credit_cards = {};
  // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
  this.sale_total = 0.0;
  // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
  this.initialized = false;
  // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
  this.content_box = false;
  // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
  this.current_total = 0.0;
  // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
  this.payment_box = false;

  // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
  this.init = function() {
    if (this.initialized) return true;

    this.list = {};
    this.cash = 0.0;
    this.change = 0.0;
    this.credit_charge = 0.0;
    this.credit_deposit = 0.0;
    this.credit_deposit_type = 0;
    this.credit_withdraws = {};
    this.gift_cards = {};
    this.credit_cards = {};
    this.sale_total = 0.0;
    this.content_box = false;
    this.current_total = 0.0;
    this.payment_box = false;

    const sale_total = window.singleElementById('sale_total');
    if (sale_total) this.sale_total = window.getMoney(sale_total.innerHTML);

    this.field_payments = window.singleElementById('payments_total2');
    this.field_balance = window.singleElementById('sale_balance');

    this.input_total_payments = window.singleElementById('payments_total');

    if (!this.field_payments || !this.field_balance || !this.input_total_payments) {
      return false;
    }

    this.initialized = true;
    return true;
  };

  // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
  this.creditCardTotal = function() {
    let total = 0;
    let id;
    const $processedRefunds = $('#processed_credit_card_refunds');
    for (id in this.credit_cards) {
      if ($processedRefunds.length) {
        // processed refunds will already be accounted for in the totals for
        // refunds so don't add terminal payments to the total
        if (!(this.credit_cards[id].emv && this.credit_cards[id].amount < 0)) {
          total += Number(this.credit_cards[id].amount);
        }
      } else {
        total += Number(this.credit_cards[id].amount);
      }
    }

    return total;
  };

  // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
  this.onChange = function(input, maximum) {
    if (window.merchantos.register.in_process) return false;

    if (!this.init()) {
      return false;
    }

    let is_cash = false;
    if (input) {
      let amount = window.getMoney(input.value);
      amount = Math.abs(amount);
      if (maximum && amount > maximum) amount = maximum;
      input.value = amount.toFixed(2);
      if (window.moneycomp(this.sale_total, '<', 0)) amount *= -1;
      if (input.id == 'cash_payment') {
        if (window.moneycomp(this.sale_total, '==', 0) && window.moneycomp(amount, '>', 0)) {
          input.value = '0.00';
          amount = 0.0;
          window.alertUser(
            `You can not enter a cash payment because the sale total is ${window.merchantos.locale.currency_symbol}0.`
          );
        }
        this.cash = amount;
        is_cash = true;
      } else if (input.id == 'charge_account_payment') {
        this.credit_charge = amount;
      } else {
        this.list[input.id] = amount;
      }
    }

    let total = 0;
    let id;
    for (id in this.list) {
      total += Number(this.list[id]);
    }
    total += this.creditCardTotal();
    for (id in this.gift_cards) {
      total += Number(this.gift_cards[id]);
    }

    total += Number(this.credit_charge);

    if (window.moneycomp(this.sale_total, '>=', 0)) {
      if (window.moneycomp(total, '>', this.sale_total) && !is_cash) {
        window.alertUser('You can not enter a payment greater than the sale total.');
        if (input) {
          input.value = '0.00';
          this.list[input.id] = 0.0;
        }
        return false;
      }
    } else if (window.moneycomp(total, '<', this.sale_total)) {
      window.alertUser('You can not enter a refund greater than the total.');
      if (input) {
        input.value = '0.00';
        this.list[input.id] = 0.0;
      }
      return false;
    }

    total += Number(this.cash);

    let balance;
    const $cash_remainder = $('#cash_remainder');

    if (window.moneycomp(total, '==', this.sale_total) || this.cash <= 0) {
      $cash_remainder.html('');
    } else if (window.moneycomp(total, '>', this.sale_total)) {
      balance = Number(total - this.sale_total);
      $cash_remainder.html(
        `<span class="green">Balance: <span id="cash_remainder_balance" notranslate>${window.formatMoney(
          // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'number' is not assignable to par... Remove this comment to see the full error message
          balance
        )}</span></span>`
      );
    } else {
      balance = Number(this.sale_total - total);
      $cash_remainder.html(
        `<span class="red">Balance: <span id="cash_remainder_balance" notranslate>${window.formatMoney(
          // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'number' is not assignable to par... Remove this comment to see the full error message
          balance
        )}</span></span>`
      );
    }

    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'number' is not assignable to par... Remove this comment to see the full error message
    this.input_total_payments.value = window.formatMoney(Math.abs(total - this.change));
    this.current_total = total - this.change;
    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'number' is not assignable to par... Remove this comment to see the full error message
    this.field_payments.innerHTML = window.formatMoney(total - this.change);

    const diff = this.sale_total - total;

    if (window.moneycomp(this.sale_total, '>=', 0)) {
      if (window.moneycomp(diff, '<=', 0)) {
        this.field_balance.style.color = 'rgb(85,170,85)';
        this.field_balance.innerHTML = `${window.merchantos.locale.currency_symbol}0.00`;
      } else {
        this.field_balance.style.color = 'rgb(255,0,0)';
        // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'number' is not assignable to par... Remove this comment to see the full error message
        this.field_balance.innerHTML = window.formatMoney(this.sale_total - total);
      }
    } else {
      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'number' is not assignable to par... Remove this comment to see the full error message
      this.field_balance.innerHTML = window.formatMoney(this.sale_total - total);
      if (window.moneycomp(diff, '==', 0)) this.field_balance.style.color = 'rgb(85,170,85)';
      else this.field_balance.style.color = 'rgb(255,0,0)';
    }

    return true;
  };

  // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
  this.getBalanceOwed = function() {
    if (!this.init()) {
      return false;
    }

    let total = Number(this.credit_charge);
    let id;
    for (id in this.list) {
      total += Number(this.list[id]);
    }
    total += this.creditCardTotal();
    for (id in this.gift_cards) {
      total += Number(this.gift_cards[id]);
    }
    total += Number(this.cash);

    total -= this.change;

    const balance = this.sale_total - total;
    return balance;
  };

  // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
  this.validate = function() {
    if (!this.init()) {
      return false;
    }

    let total = Number(this.credit_charge);
    let id;
    for (id in this.list) {
      total += Number(this.list[id]);
    }
    total += this.creditCardTotal();
    for (id in this.gift_cards) {
      total += Number(this.gift_cards[id]);
    }

    const required_payment = this.sale_total;

    if (window.moneycomp(this.sale_total, '>=', 0)) {
      if (window.moneycomp(total + this.cash, '<', required_payment)) {
        window.alertUser('Payments are insufficient.');
        return false;
      }
      if (window.moneycomp(total, '>', required_payment)) {
        window.alertUser('There are more payments than necessary. Remove or reduce payments.');
        return false;
      }
    } else {
      if (window.moneycomp(total + this.cash, '>', this.sale_total)) {
        window.alertUser('Refunds are insufficient.');
        return false;
      }
      if (window.moneycomp(total, '<', this.sale_total)) {
        window.alertUser('There are more refunds than necessary. Remove or reduce refunds.');
        return false;
      }
    }

    return true;
  };

  // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
  this.replaceContent = function(html) {
    if (!this.payment_box) this.payment_box = window.singleElementById('payments_content');
    if (!this.payment_box) return false;

    // Store live NodeList as a static array
    if (!this.payment_box.oldNodes) {
      this.payment_box.oldNodes = Array.from(this.payment_box.childNodes);
    }

    // Insert new HTML
    this.payment_box.innerHTML = html;
    return true;
  };

  // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
  this.restoreContent = function() {
    if (!this.payment_box) this.payment_box = window.singleElementById('payments_content');
    if (!this.payment_box) return false;
    if (!this.payment_box.oldNodes) return true;

    // Empty element without using innerHTML again
    while (this.payment_box.firstChild) {
      this.payment_box.removeChild(this.payment_box.firstChild);
    }
    // Insert previous nodes
    while (this.payment_box.oldNodes[0]) {
      this.payment_box.appendChild(this.payment_box.oldNodes.shift());
    }
    // Unset
    this.payment_box.oldNodes = null;

    for (const id in this.list) {
      const input = window.singleElementById(id);
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'value' does not exist on type 'HTMLEleme... Remove this comment to see the full error message
      if (input) input.value = window.formatMoney(Math.abs(this.list[id]), true);
    }
    const cash_payment = window.singleElementById('cash_payment');
    if (cash_payment) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'value' does not exist on type 'HTMLEleme... Remove this comment to see the full error message
      cash_payment.value = window.formatMoney(this.cash, true);
      window.merchantos.focus.set('cash_payment');
    }
    return true;
  };

  // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
  this.completeSale = function(input_id) {
    if (input_id) this.onChange(window.singleElementById(input_id));
    if (window.moneycomp(Math.abs(this.getBalanceOwed()), '>', 0)) return;
    window.merchantos.register.completeSale();
  };

  // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
  this.addToCash = function(amount) {
    if (!this.init()) {
      return false;
    }
    const cash_input = window.singleElementById('cash_payment');
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    cash_input.value = (amount + this.cash).toFixed(2);
    this.onChange(cash_input);
    return true;
  };

  // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
  this.setToMax = function(input, max) {
    if (!input) {
      return false;
    }

    if (!this.init()) {
      return false;
    }

    if (input.id == 'cash_payment') {
      this.cash = 0;
    } else if (input.id == 'charge_account_payment') {
      this.credit_charge = 0;
    } else {
      this.list[input.id] = 0;
    }

    let set_to = Math.abs(this.getBalanceOwed());

    if (max) {
      max = Math.abs(max);
      if (window.moneycomp(this.sale_total, '>', max)) set_to = Math.abs(max);
    }

    input.value = set_to.toFixed(2);

    this.onChange(input);

    // Focus amount field, so they can hit "enter" to continue on desktop
    if (!window.isMobileDevice()) {
      input.focus();
    }

    return true;
  };

  // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
  this.addSpecialPaymentHTML = function(id, name, amount, removebtn) {
    const data_automation_prefix = name.replace(/ +/g, '');
    const s_table_html = `<table class='refunds_list' width='100%' cellpadding='0' cellspacing='0' border='0' style='border: none;'><tr><th data-automation="${data_automation_prefix}Label">${name}</th><td data-automation="${data_automation_prefix}Amount" style="text-align: right;">${amount}</td><td>${removebtn}</td></tr></table>`;

    const payment_div = window.singleElementById(id);
    if (payment_div) {
      payment_div.innerHTML = s_table_html;
      return;
    }

    const special_payments_list = window.singleElementById('special_payments_list');

    if (!special_payments_list) return;

    special_payments_list.innerHTML += `<div id='${id}' data-automation='${data_automation_prefix}Row'>${s_table_html}</div>`;
  };

  // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
  this.removeSpecialPayment = function(id) {
    const tr = window.singleElementById(id);

    if (!tr) return;

    if (!tr.parentNode) return;

    tr.parentNode.removeChild(tr);
  };

  // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
  this.addEmvPayment = function(payment) {
    const $specialPaymentsList = $('#special_payments_list');
    if ($specialPaymentsList.length) {
      let $emvPayments = $('#emv_payments_list');
      if ($emvPayments.length === 0) {
        $emvPayments = $('<table><tbody></tbody></table>');
        $emvPayments.prop('id', 'emv_payments_list');
        $emvPayments.addClass('emv-payments');
        $specialPaymentsList.append($emvPayments);
      }

      const $paymentDescription = $('<th/>');
      $paymentDescription.addClass('payment-description');

      let transactionDescription =
        payment.CCCharge && payment.CCCharge.isDebit === 'true' ? 'Debit' : 'Credit Card';

      // For terminal transactions without back-end support to the gateway we won't
      // have a CCCharge
      if (payment.CCCharge) {
        transactionDescription += `<br>${payment.CCCharge.cardType} (${payment.CCCharge.xnum})`;
      }
      $paymentDescription.htmlReplace(transactionDescription);

      const $paymentAmount = $('<td/>');
      $paymentAmount.addClass('payment-amount');
      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'number' is not assignable to par... Remove this comment to see the full error message
      $paymentAmount.text(window.formatMoney(Number(payment.amount)));

      const $paymentRemoveButton = $('<td><button class="gui-def-button">Remove</button></td>');
      $paymentRemoveButton.addClass('remove-emv-payment');

      if (payment.transactionReferenceID) {
        $paymentRemoveButton
          .find('button')
          .attr(
            'onclick',
            `window.merchantos.register.partial_payments.voidTransactionByReference("${payment.saleID}", "${payment.transactionReferenceID}", "${payment.amount}");`
          );
      } else {
        $paymentRemoveButton
          .find('button')
          .attr(
            'onclick',
            `window.merchantos.register.partial_payments.voidTransaction("${payment.saleID}", "${payment.salePaymentID}");`
          );
      }

      const $paymentContainer = $('<tr/>');
      $paymentContainer.attr('payment_type_id', payment.paymentTypeID);

      if (payment.transactionReferenceID) {
        // For terminal payments without back-end gateway support all
        // we'll have is a transactionReferenceID.  We'll loose the
        // payment if we navigate away from the payments screen since
        // no payment will have been registered with the back-end.
        $paymentContainer.attr('transaction_reference_id', payment.transactionReferenceID);
      } else {
        $paymentContainer.attr('payment_id', payment.salePaymentID);
        $paymentContainer.attr('cc_charge_id', payment.ccChargeID || 0);
      }

      $paymentContainer
        .append($paymentDescription)
        .append($paymentAmount)
        .append($paymentRemoveButton);

      $emvPayments.find('tbody').append($paymentContainer);

      $specialPaymentsList.append($emvPayments);
    }
  };

  // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
  this.removeEmvPayment = function(paymentID) {
    const $paymentList = $('#special_payments_list');

    // the payment ID can be either a sale payment ID or a transaction reference ID
    $paymentList.find(`tr[payment_id=${paymentID}]`).remove();
    $paymentList.find(`tr[transaction_reference_id=${paymentID}]`).remove();
  };
})();

// @ts-expect-error ts-migrate(2339) FIXME: Property 'refund' does not exist on type 'Merchant... Remove this comment to see the full error message
window.merchantos.register.refund = new (function() {
  // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
  this.open = function(type_id) {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
    window.merchantos.register.payments.init();

    // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
    if (window.moneycomp(Math.abs(window.merchantos.register.payments.getBalanceOwed()), '<=', 0)) {
      window.alertUser('There is no balance left to refund.');
      return false;
    }

    const content_map = {} as ContentMap;
    content_map.form_name = 'register.refunds.payment_type';
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'sale_total' does not exist on type 'Cont... Remove this comment to see the full error message
    content_map.sale_total = window.merchantos.register.payments.sale_total;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'total_payments' does not exist on type '... Remove this comment to see the full error message
    content_map.total_payments = window.merchantos.register.payments.current_total;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Conten... Remove this comment to see the full error message
    content_map.payments = window.toJsonString(window.merchantos.register.payments.list);
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'type_id' does not exist on type 'Content... Remove this comment to see the full error message
    content_map.type_id = type_id;
    window.doServerCall(content_map, function(result) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'refund' does not exist on type 'Merchant... Remove this comment to see the full error message
      window.merchantos.register.refund.onreturn(result);
    });
    return true;
  };

  // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
  this.addRefund = function(input, name, type_id, max) {
    input = window.singleElementById(input);
    if (!input || !input.value) return false;
    let amount = window.getMoney(input.value);
    if (window.moneycomp(amount, '>', max)) {
      window.alertUser('Refund entered is greater than the allowed amount.');
      input.value = window.formatMoney(max);
      return false;
    }

    this.close();

    // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
    window.merchantos.register.payments.init();
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
    if (window.moneycomp(window.merchantos.register.payments.sale_total, '<', 0)) {
      amount = Math.abs(amount) * -1.0;
    }

    // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
    window.merchantos.register.payments.list[`payment_type_${type_id}`] = amount;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
    if (!window.merchantos.register.payments.onChange()) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
      window.merchantos.register.payments.list[`payment_type_${type_id}`] = 0.0;
      return false;
    }

    const remove_btn = `<button onclick="window.merchantos.register.refund.removeRefund(${type_id}); return false;" class="gui-def-button">Remove</button>`;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
    window.merchantos.register.payments.addSpecialPaymentHTML(
      `refund_payment_type_${type_id}`,
      name,
      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'number' is not assignable to par... Remove this comment to see the full error message
      window.formatMoney(Math.abs(amount)),
      remove_btn
    );

    window.flashNotifier(
      'success',
      `<var>${name}</var> Refund Of <var>${window.formatMoney(
        // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'number' is not assignable to par... Remove this comment to see the full error message
        amount
      )}</var> Added.`,
      4
    );

    return true;
  };

  // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
  this.removeRefund = function(type_id) {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
    window.merchantos.register.payments.removeSpecialPayment(`refund_payment_type_${type_id}`);
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
    if (window.merchantos.register.payments.list[`payment_type_${type_id}`])
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
      window.merchantos.register.payments.list[`payment_type_${type_id}`] = 0.0;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
    window.merchantos.register.payments.onChange();
  };
  // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
  this.onreturn = function(result) {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
    if (result.html) window.merchantos.register.payments.replaceContent(result.html);
    if (result.focus) window.merchantos.focus.set(result.focus);
    if (result.cancel) this.close();
  };
  // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
  this.close = function() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
    window.merchantos.register.payments.restoreContent();
  };
})();

// @ts-expect-error ts-migrate(2339) FIXME: Property 'gift_card' does not exist on type 'Merch... Remove this comment to see the full error message
window.merchantos.register.gift_card = new (function() {
  // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
  this.open = function(charge_amount) {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
    window.merchantos.register.payments.init();

    // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
    if (window.moneycomp(Math.abs(window.merchantos.register.payments.getBalanceOwed()), '<=', 0)) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
      if (window.moneycomp(window.merchantos.register.payments.sale_total, '>=', 0))
        window.alertUser('There is no balance left to pay.');
      else window.alertUser('There is no balance left to refund.');
      return;
    }

    const content_map = {} as ContentMap;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
    if (window.moneycomp(window.merchantos.register.payments.sale_total, '>=', 0)) {
      content_map.form_name = 'register.payments.gift_card';
    } else {
      content_map.form_name = 'register.refunds.gift_card';
    }
    if (charge_amount) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'charge_amount' does not exist on type 'C... Remove this comment to see the full error message
      content_map.charge_amount = charge_amount;
    }
    window.doServerCall(content_map, function(result) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'gift_card' does not exist on type 'Merch... Remove this comment to see the full error message
      window.merchantos.register.gift_card.onreturn(result);
    });
    return true;
  };
  // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
  this.close = function() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
    window.merchantos.register.payments.restoreContent();
  };
  // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
  this.addPayment = function(input, gift_card_id, max) {
    input = window.singleElementById(input);
    if (!input || !input.value) return false;
    let amount = window.getMoney(input.value);
    if (window.moneycomp(amount, '>', max)) {
      window.alertUser(
        'Gift card charge can not be larger than the available balance on the card.'
      );
      input.value = window.formatMoney(max);
      return false;
    }

    this.close();

    // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
    window.merchantos.register.payments.init();
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
    if (window.moneycomp(window.merchantos.register.payments.sale_total, '<', 0)) {
      amount = Math.abs(amount) * -1.0;
    }

    // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
    window.merchantos.register.payments.gift_cards[gift_card_id] = amount;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
    if (!window.merchantos.register.payments.onChange()) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
      window.merchantos.register.payments.gift_cards[gift_card_id] = 0.0;
      return false;
    }

    const remove_btn = `<button id="remove_gift_card_payment_button" onclick="window.merchantos.register.gift_card.removePayment('${gift_card_id}'); return false;" class="gui-def-button">Remove</button>`;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
    window.merchantos.register.payments.addSpecialPaymentHTML(
      `gift_card_payment_${gift_card_id}`,
      'Gift Card',
      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'number' is not assignable to par... Remove this comment to see the full error message
      window.formatMoney(Math.abs(amount)),
      remove_btn
    );

    // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
    if (window.merchantos.register.payments.sale_total < 0) {
      window.flashNotifier(
        'success',
        `Gift Card Refund Of <var>${window.formatMoney(
          // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'number' is not assignable to par... Remove this comment to see the full error message
          amount
        )}</var> Added.`,
        4
      );
    } else {
      window.flashNotifier(
        'success',
        `Gift Card Payment Of <var>${window.formatMoney(
          // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'number' is not assignable to par... Remove this comment to see the full error message
          amount
        )}</var> Added.`,
        4
      );
    }

    return true;
  };

  // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
  this.removePayment = function(gift_card_id) {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
    window.merchantos.register.payments.removeSpecialPayment(`gift_card_payment_${gift_card_id}`);
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
    if (window.merchantos.register.payments.gift_cards[gift_card_id])
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
      window.merchantos.register.payments.gift_cards[gift_card_id] = 0.0;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
    window.merchantos.register.payments.onChange();
  };

  // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
  this.submitScan = function(input) {
    input = window.singleElementById(input);
    if (!input) return false;

    // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
    window.merchantos.register.payments.init();

    const content_map = {} as ContentMap;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
    if (window.moneycomp(window.merchantos.register.payments.sale_total, '>=', 0)) {
      content_map.form_name = 'register.payments.gift_card';
    } else {
      content_map.form_name = 'register.refunds.gift_card';
    }
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'card_scan' does not exist on type 'Conte... Remove this comment to see the full error message
    content_map.card_scan = input.value;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'sale_total' does not exist on type 'Cont... Remove this comment to see the full error message
    content_map.sale_total = window.merchantos.register.payments.sale_total;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'total_payments' does not exist on type '... Remove this comment to see the full error message
    content_map.total_payments = window.merchantos.register.payments.current_total;
    window.doServerCall(content_map, function(result) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'gift_card' does not exist on type 'Merch... Remove this comment to see the full error message
      window.merchantos.register.gift_card.onreturn(result);
    });
    return true;
  };

  // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
  this.onreturn = function(result) {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
    if (result.html) window.merchantos.register.payments.replaceContent(result.html);
    if (result.focus) window.merchantos.focus.set(result.focus);
    if (result.cancel) this.close();
  };
})();

// @ts-expect-error ts-migrate(2339) FIXME: Property 'credit_card' does not exist on type 'Mer... Remove this comment to see the full error message
window.merchantos.register.credit_card = new (function() {
  // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
  this.current_id = 0;

  // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
  this.open = function(charge_amount, emvEnabled, saleID) {
    // SUPER HACKY. Like, dear-lord-why-can't-we-have-nice-things hacky.
    // Long story short, this scenario only happens when we're trying
    // to Refund on New Card and are using an iPad Swiper rather than
    // a terminal. See CLD-12659

    // I made this is specific as possible on purpose. Basically,
    // If you're using Retail Manager,
    // AND you're doing a refund,
    // AND you're on the correct Payments View,
    // AND the page is being loaded as a result of a Stencil API call,
    // then load the USB Swiper Refund view
    if (
      window.isGriffin() &&
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
      window.moneycomp(window.merchantos.register.payments.sale_total, '<', 0) &&
      $('button#refundOnNewCard').length > 0 &&
      typeof charge_amount === 'undefined' &&
      typeof emvEnabled === 'undefined' &&
      typeof saleID === 'undefined'
    ) {
      this.openCreditCardForRefund();

      return false;
    }
    // End of hack. I'm so sorry.

    // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
    window.merchantos.register.payments.init();

    if (
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'credit_card' does not exist on type 'Mer... Remove this comment to see the full error message
      window.merchantos.register.credit_card.startNativePayment(charge_amount, emvEnabled, saleID)
    ) {
      return false; // payment being handled natively; nothing more to do
    }

    // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
    if (window.moneycomp(Math.abs(window.merchantos.register.payments.getBalanceOwed()), '<=', 0)) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
      if (window.moneycomp(window.merchantos.register.payments.sale_total, '>=', 0)) {
        window.alertUser('There is no balance left to pay.');
      } else {
        window.alertUser('There is no balance left to refund.');
      }
      return false;
    }

    const content_map = {} as ContentMap;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
    if (window.moneycomp(window.merchantos.register.payments.sale_total, '>=', 0)) {
      content_map.form_name = 'register.payments.credit_card';
    } else {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'credit_cards' does not exist on type 'Co... Remove this comment to see the full error message
      content_map.credit_cards = window.toJsonString(
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
        window.merchantos.register.payments.credit_cards
      );
      content_map.form_name = 'register.refunds.credit_card';
    }
    if (charge_amount) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'charge_amount' does not exist on type 'C... Remove this comment to see the full error message
      content_map.charge_amount = charge_amount;
    }

    if (emvEnabled) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'emv_payment' does not exist on type 'Con... Remove this comment to see the full error message
      content_map.emv_payment = true;
    }

    // @ts-expect-error ts-migrate(2339) FIXME: Property 'total_payments' does not exist on type '... Remove this comment to see the full error message
    content_map.total_payments = window.merchantos.register.payments.current_total;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'sale_total' does not exist on type 'Cont... Remove this comment to see the full error message
    content_map.sale_total = window.merchantos.register.payments.sale_total;
    window.doServerCall(content_map, function(result) {
      // for ad hoc payments, an EMV payment maybe triggered if there are no existing payments
      // in the sale so handle that accordingly
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'emv_payment' does not exist on type 'Par... Remove this comment to see the full error message
      if (result.emv_payment) {
        if (
          // @ts-expect-error ts-migrate(2339) FIXME: Property 'credit_card' does not exist on type 'Mer... Remove this comment to see the full error message
          window.merchantos.register.credit_card.startNativePayment(
            charge_amount,
            emvEnabled,
            saleID
          )
        ) {
          return false; // payment being handled natively; nothing more to do
        }
      }

      // @ts-expect-error ts-migrate(2339) FIXME: Property 'credit_card' does not exist on type 'Mer... Remove this comment to see the full error message
      window.merchantos.register.credit_card.onreturn(result);
    });
    return true;
  };

  // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
  this.startNativePayment = function(chargeAmount, emvEnabled, saleID) {
    if (window.isGriffin()) {
      if (emvEnabled) {
        if (!saleID) {
          console.error('No sale ID specified; cannot initiate the transaction');
        } else {
          if (!chargeAmount) {
            // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
            chargeAmount = window.merchantos.register.payments.getBalanceOwed();
          }
          window.StencilWebAPI.cardReader.initiatePaymentTerminalTransaction(
            saleID.toString(),
            chargeAmount
          );
        }
        return true; // native payment attempted
      }
      window.StencilWebAPI.cardReader.enableHighPoweredReader(true);
    }

    return false; // native payment not attempted
  };

  // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
  this.openManualEntry = function(amount) {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
    window.merchantos.register.payments.init();
    const content_map = {} as ContentMap;
    content_map.form_name = 'register.payments.credit_card';
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'manual_entry' does not exist on type 'Co... Remove this comment to see the full error message
    content_map.manual_entry = true;
    if (amount) {
      amount = window.singleElementById(amount);
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'charge_amount' does not exist on type 'C... Remove this comment to see the full error message
      content_map.charge_amount = amount.value;
    } else {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'charge_amount' does not exist on type 'C... Remove this comment to see the full error message
      content_map.charge_amount = window.merchantos.register.payments.getBalanceOwed();
    }
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'total_payments' does not exist on type '... Remove this comment to see the full error message
    content_map.total_payments = window.merchantos.register.payments.current_total;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'sale_total' does not exist on type 'Cont... Remove this comment to see the full error message
    content_map.sale_total = window.merchantos.register.payments.sale_total;
    window.doServerCall(content_map, function(result) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'credit_card' does not exist on type 'Mer... Remove this comment to see the full error message
      window.merchantos.register.credit_card.onreturn(result);
    });
    return true;
  };

  // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
  this.openRefund = function(id) {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
    window.merchantos.register.payments.init();

    const content_map = {} as ContentMap;
    content_map.form_name = 'register.refunds.credit_card';
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'payment_id' does not exist on type 'Cont... Remove this comment to see the full error message
    content_map.payment_id = id;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'total_payments' does not exist on type '... Remove this comment to see the full error message
    content_map.total_payments = window.merchantos.register.payments.current_total;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'sale_total' does not exist on type 'Cont... Remove this comment to see the full error message
    content_map.sale_total = window.merchantos.register.payments.sale_total;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'credit_cards' does not exist on type 'Co... Remove this comment to see the full error message
    content_map.credit_cards = window.toJsonString(
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
      window.merchantos.register.payments.credit_cards
    );
    window.doServerCall(content_map, function(result) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'credit_card' does not exist on type 'Mer... Remove this comment to see the full error message
      window.merchantos.register.credit_card.onreturn(result);
    });
    return true;
  };

  // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
  this.openCreditCardForRefund = function(id, emvEnabled, saleID) {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
    window.merchantos.register.payments.init();

    // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
    const charge_amount = window.merchantos.register.payments.getBalanceOwed();
    if (
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'credit_card' does not exist on type 'Mer... Remove this comment to see the full error message
      window.merchantos.register.credit_card.startNativePayment(charge_amount, emvEnabled, saleID)
    ) {
      return false; // payment being handled natively; nothing more to do
    }

    const content_map = {} as ContentMap;
    content_map.form_name = 'register.payments.credit_card';
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'payment_id' does not exist on type 'Cont... Remove this comment to see the full error message
    content_map.payment_id = id;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'total_payments' does not exist on type '... Remove this comment to see the full error message
    content_map.total_payments = window.merchantos.register.payments.current_total;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'sale_total' does not exist on type 'Cont... Remove this comment to see the full error message
    content_map.sale_total = window.merchantos.register.payments.sale_total;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'credit_cards' does not exist on type 'Co... Remove this comment to see the full error message
    content_map.credit_cards = window.toJsonString(
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
      window.merchantos.register.payments.credit_cards
    );

    if (emvEnabled) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'emv_payment' does not exist on type 'Con... Remove this comment to see the full error message
      content_map.emv_payment = true;
    }

    window.doServerCall(content_map, function(result) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'emv_payment' does not exist on type 'Par... Remove this comment to see the full error message
      if (result.emv_payment) {
        if (
          // @ts-expect-error ts-migrate(2339) FIXME: Property 'credit_card' does not exist on type 'Mer... Remove this comment to see the full error message
          window.merchantos.register.credit_card.startNativePayment(
            charge_amount,
            emvEnabled,
            saleID
          )
        ) {
          return false; // payment being handled natively; nothing more to do
        }
      }

      // @ts-expect-error ts-migrate(2339) FIXME: Property 'credit_card' does not exist on type 'Mer... Remove this comment to see the full error message
      window.merchantos.register.credit_card.onreturn(result);
    });

    return true;
  };

  // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
  this.close = function() {
    if (window.isGriffin()) {
      window.StencilWebAPI.cardReader.enableHighPoweredReader(false);
    }
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
    window.merchantos.register.payments.restoreContent();
  };

  // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
  this.submitSwipe = function(swipe_input, amount_input) {
    swipe_input = window.singleElementById(swipe_input);
    amount_input = window.singleElementById(amount_input);
    if (!swipe_input || !swipe_input.value || !amount_input || !amount_input.value) {
      window.merchantos.focus.set('credit_card_input');
      return false;
    }

    const unreadable_regex = /(0{150})/i;
    if (unreadable_regex.exec(swipe_input.value)) {
      window.alertUser(
        'This credit card type can not be read by this device. Please use manual entry instead of swiping for this credit card.'
      );
      window.merchantos.focus.set('credit_card_input');
      return false;
    }

    const new_credit_card = {};
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'amount' does not exist on type '{}'.
    new_credit_card.amount = window.getMoney(amount_input.value);
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'card_swipe' does not exist on type '{}'.
    new_credit_card.card_swipe = swipe_input.value;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'card_num' does not exist on type '{}'.
    new_credit_card.card_num = this.parseSwipe(new_credit_card.card_swipe);

    // @ts-expect-error ts-migrate(2339) FIXME: Property 'card_num' does not exist on type '{}'.
    if (!new_credit_card.card_num) {
      window.alertUser('Credit card invalid. Please try again.');
      window.merchantos.focus.set('credit_card_input');
      return false;
    }

    return this.addPayment(new_credit_card);
  };

  // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
  this.submitManualEntry = function(form_id, amount_input) {
    amount_input = window.singleElementById(amount_input);
    if (!amount_input || !amount_input.value) {
      return false;
    }

    const new_credit_card = {};
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'amount' does not exist on type '{}'.
    new_credit_card.amount = window.getMoney(amount_input.value);
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'manual_entry' does not exist on type '{}... Remove this comment to see the full error message
    new_credit_card.manual_entry = {};

    const fields = new Array(
      'card_number',
      'cvv',
      'exp_month',
      'exp_year',
      'f_name',
      'l_name',
      'company',
      'phone',
      'fax',
      'mail_order',
      'address',
      'city',
      'state',
      'zip',
      'country',
      'ship_f_name',
      'ship_l_name',
      'ship_company',
      'ship_address',
      'ship_city',
      'ship_state',
      'ship_zip',
      'ship_country'
    );
    const form = window.singleElementById(form_id);
    for (let i = 0; i < fields.length; i++) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'manual_entry' does not exist on type '{}... Remove this comment to see the full error message
      new_credit_card.manual_entry[fields[i]] = window.getFormFieldValue(form[fields[i]]);
    }

    // @ts-expect-error ts-migrate(2339) FIXME: Property 'manual_entry' does not exist on type '{}... Remove this comment to see the full error message
    const card_num = new_credit_card.manual_entry.card_number;

    if (!card_num.length || card_num.length < 5) {
      window.alertUser('Credit card invalid. Please try again.');
      window.merchantos.focus.set('card_number');
      return false;
    }
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'card_num' does not exist on type '{}'.
    new_credit_card.card_num = card_num.substring(card_num.length - 5);

    return this.addPayment(new_credit_card);
  };

  // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
  this.submitPreHostedPage = function(form_id, amount_input) {
    amount_input = window.singleElementById(amount_input);
    if (!amount_input || !amount_input.value) {
      return false;
    }

    const new_credit_card = {};
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'amount' does not exist on type '{}'.
    new_credit_card.amount = window.getMoney(amount_input.value);
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'manual_entry' does not exist on type '{}... Remove this comment to see the full error message
    new_credit_card.manual_entry = {};

    const fields = new Array(
      'card_not_present',
      'f_name',
      'l_name',
      'company',
      'phone',
      'mail_order',
      'address',
      'address2',
      'city',
      'state',
      'zip',
      'country',
      'ship_f_name',
      'ship_l_name',
      'ship_company',
      'ship_address',
      'ship_address2',
      'ship_city',
      'ship_state',
      'ship_zip',
      'ship_country',
      'ship_phone'
    );
    const form = window.singleElementById(form_id);
    for (let i = 0; i < fields.length; i++) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'manual_entry' does not exist on type '{}... Remove this comment to see the full error message
      new_credit_card.manual_entry[fields[i]] = window.getFormFieldValue(form[fields[i]]);
    }

    // @ts-expect-error ts-migrate(2339) FIXME: Property 'card_num' does not exist on type '{}'.
    new_credit_card.card_num = 'XXXX';

    return this.addPayment(new_credit_card);
  };

  // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
  this.addPayment = function(new_credit_card) {
    this.close();

    if (window.moneycomp(new_credit_card.amount, '==', 0)) {
      return false;
    }

    const payment_id = this.current_id;
    this.current_id++;

    new_credit_card.amount = Math.abs(new_credit_card.amount);
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
    if (window.moneycomp(window.merchantos.register.payments.sale_total, '<', 0)) {
      new_credit_card.amount *= -1;
    }

    // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
    window.merchantos.register.payments.credit_cards[payment_id] = new_credit_card;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
    if (!window.merchantos.register.payments.onChange()) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
      delete window.merchantos.register.payments.credit_cards[payment_id];
      return false;
    }

    if (
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
      window.moneycomp(window.merchantos.register.payments.sale_total, '>', 0) &&
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
      window.moneycomp(window.merchantos.register.payments.getBalanceOwed(), '==', 0.0)
    ) {
      // we should complete the sale because we are paying the full balance
      // so send the extra parameters to complete the sale
      window.merchantos.register.completeSale();
      return true;
    }

    const remove_btn = `<button onclick="window.merchantos.register.credit_card.removePayment('${payment_id}'); return false;" class="gui-def-button">Remove</button>`;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
    window.merchantos.register.payments.addSpecialPaymentHTML(
      `credit_card_payment_${payment_id}`,
      `Credit Card ${new_credit_card.card_num}`,
      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'number' is not assignable to par... Remove this comment to see the full error message
      window.formatMoney(Math.abs(new_credit_card.amount)),
      remove_btn
    );
    window.flashNotifier(
      'success',
      `Card ${new_credit_card.card_num} Payment Of ${window.formatMoney(
        new_credit_card.amount
      )} Added. Charge is NOT yet processed. It will be processed when you press Finish Sale.`,
      9
    );

    return true;
  };

  // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
  this.removePayment = function(payment_id, skip_onchange) {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
    if (window.merchantos.register.payments.credit_cards[payment_id].refund_processed) {
      window.alertUser('Can not remove credit card refund because it has already been processed.');
      return true;
    }
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
    window.merchantos.register.payments.removeSpecialPayment(`credit_card_payment_${payment_id}`);
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
    if (window.merchantos.register.payments.credit_cards[payment_id]) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
      delete window.merchantos.register.payments.credit_cards[payment_id];
    }
    if (!skip_onchange) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
      window.merchantos.register.payments.onChange();
    }
    return true;
  };

  // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
  this.addEmvPayment = function(payment) {
    if (!payment.CCCharge && !payment.transactionReferenceID) {
      console.error('No charge associated with the payment');
      return;
    }

    // @ts-expect-error ts-migrate(2339) FIXME: Property 'credit_card' does not exist on type 'Mer... Remove this comment to see the full error message
    window.merchantos.register.credit_card.addEmvPaymentToPaymentsList(payment);

    // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
    window.merchantos.register.payments.addEmvPayment(payment);
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
    window.merchantos.register.payments.onChange();
  };

  // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
  this.addEmvPaymentToPaymentsList = function(payment) {
    const payment_id = this.current_id;
    this.current_id++;

    // create a credit card transaction compatible with the existing payment structure;
    // the naming of the attributes is important in order for the payment to be processed
    // correctly when finishing the sale
    const paymentData = {
      amount: Number(payment.amount),
      payment_type_id: payment.paymentTypeID,
    };

    if (!payment.transactionReferenceID) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'transaction_payment_id' does not exist o... Remove this comment to see the full error message
      paymentData.transaction_payment_id = payment.salePaymentID;
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'cc_charge_id' does not exist on type '{ ... Remove this comment to see the full error message
      paymentData.cc_charge_id = payment.ccChargeID;
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'emv' does not exist on type '{ amount: n... Remove this comment to see the full error message
      paymentData.emv = true;
    } else {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'transaction_reference_id' does not exist... Remove this comment to see the full error message
      paymentData.transaction_reference_id = payment.transactionReferenceID;
    }

    // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
    window.merchantos.register.payments.credit_cards[payment_id] = paymentData;
  };

  // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
  this.removeEmvPayment = function(paymentID) {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'credit_card' does not exist on type 'Mer... Remove this comment to see the full error message
    window.merchantos.register.credit_card.removeEmvPaymentFromPaymentsList(paymentID);
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
    window.merchantos.register.payments.removeEmvPayment(paymentID);
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
    window.merchantos.register.payments.onChange();
  };

  // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
  this.removeEmvPaymentFromPaymentsList = function(paymentID) {
    let payment_id;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
    _.find(window.merchantos.register.payments.credit_cards, function(credit_card, key) {
      // match the payment ID against either the sale payment or the transaction
      // reference ID
      if (
        credit_card.transaction_payment_id === paymentID || // sale payment ID
        credit_card.transaction_reference_id === paymentID
      ) {
        // transaction reference ID
        payment_id = key;
        return true;
      }
      return false;
    });

    if (payment_id) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
      delete window.merchantos.register.payments.credit_cards[payment_id];
    }
  };

  // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
  this.onreturn = function(result) {
    if (result.html) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
      window.merchantos.register.payments.replaceContent(result.html);
    }

    if (result.focus) {
      window.merchantos.focus.set(result.focus);
    }
    if (result.cancel) {
      this.close();
    }
    if (result.remove_payment) {
      const payment_id = result.transaction_payment_id;
      this.removePayment(payment_id);
    }
  };

  // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
  this.removeAllCreditCards = function() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
    for (const id in window.merchantos.register.payments.credit_cards) {
      this.removePayment(id, true);
    }
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
    window.merchantos.register.payments.onChange();
  };

  // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
  this.clearAll = function() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
    for (const id in window.merchantos.register.payments.credit_cards) {
      // don't remove credit card refunds
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
      if (window.merchantos.register.payments.credit_cards[id].transaction_payment_id) {
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
        window.merchantos.register.payments.credit_cards[id].refund_processed = true;
        continue;
      }
      this.removePayment(id, true);
    }
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
    window.merchantos.register.payments.onChange();
  };

  // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
  this.parseSwipe = function(swipe: string) {
    if (swipe.length <= 0) {
      return false;
    }
    let number;

    const swipe_parts = swipe.split(':::', 2);
    if (swipe_parts && swipe_parts.length == 2) {
      const device_name = swipe_parts[0];
      const device_swipe = swipe_parts[1];

      switch (device_name) {
        case 'MagTek':
          return device_swipe.substring(16, 20);
        case 'UniMag':
          return device_swipe.substring(14, 18);
      }
    }

    let regex = /^([\%]([^\;\?]{28,77})[\?]){1}[\;]([^\;\?]{24,40})[\?]{1}.*$/m;
    const matches = regex.exec(swipe);

    if (matches === null) {
      const element42012_split = swipe.split('?*;');
      if (element42012_split && element42012_split.length == 2) {
        const element42012_track1_split = element42012_split[0].split('^');
        const element42012_track1_split2 = element42012_track1_split[0].split('%*');
        number = element42012_track1_split2[1];
        return number.substring(number.length - 4);
      }

      // see if it's a XML pin swipe
      const msk_pan_regex = /MskPAN="\d{4}\*+(\d+)"/m;
      const msk_pan_matches = msk_pan_regex.exec(swipe);
      if (msk_pan_matches && msk_pan_matches.length == 2) {
        return msk_pan_matches[1];
      }

      // perhaps it's an IPAD
      // if(swipe.indexOf("IPAD") != -1)
      const ipad_pos = swipe.indexOf('IPAD');
      let swipeArray: string[];
      if (ipad_pos >= 0 && ipad_pos <= 6) {
        swipeArray = swipe.split('|');
        let last4: string;
        if (swipeArray.length > 0) {
          const track2Data = swipeArray[8];
          const track2DataArray = track2Data.split('=');
          last4 = track2DataArray[0].substring(track2DataArray[0].length - 4);
        }

        // @ts-expect-error ts-migrate(2454) FIXME: Variable 'last4' is used before being assigned.
        return last4;
      }

      // is it a Dynamag?
      swipeArray = swipe.split('|');

      if (swipeArray.length > 9) {
        const indexOfEncryptedKey = 9;
        const encryptedKey = swipeArray[indexOfEncryptedKey];
        const MercuryTestKey = '9012090';
        const MercuryProdKey = '9012110';

        if (
          encryptedKey.indexOf(MercuryTestKey) === 0 ||
          encryptedKey.indexOf(MercuryProdKey) === 0
        ) {
          // its a dynamag

          // get last 4
          const carrotArray = swipe.split('^');
          const last4 = carrotArray[0].substring(carrotArray[0].length - 4);
          return last4;
        }
      }

      // maybe it's a MagneSafe swipe
      const tracks = swipe.split('?;');

      // original magnesafe format
      if (tracks.length < 2) {
        return false;
      }
      const track2_parts = tracks[1].split('|');
      if (track2_parts.length != 9) {
        return false;
      }
      return track2_parts[5].substring(track2_parts[5].length - 4);
    }

    if (matches.length != 4) {
      return false;
    }

    // record the tracks
    const track1 = matches[2];

    regex = /([^\^]*)/;
    const track1_matches = regex.exec(track1);

    // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
    number = track1_matches[1];

    return number.substring(number.length - 4);
  };

  // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
  this.onSwipeKeyPress = function(input, event) {
    if (
      window.onEnterKey(event, function() {
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'credit_card' does not exist on type 'Mer... Remove this comment to see the full error message
        window.merchantos.register.credit_card.submitSwipe(
          'credit_card_input',
          'credit_card_amount'
        );
      })
    ) {
      return false;
    }
    const value = input.value;
    if (value.length < 100) {
      return true;
    }

    const regex = /<\/DvcMsg>$/i;

    if (value.search(regex) > -1) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'credit_card' does not exist on type 'Mer... Remove this comment to see the full error message
      window.merchantos.register.credit_card.submitSwipe('credit_card_input', 'credit_card_amount');
      return false;
    }
    return true;
  };

  // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
  this.signaturePrompt = function(payments) {
    // @ts-expect-error ts-migrate(7034) FIXME: Variable 'cc_payments' implicitly has type 'any[]'... Remove this comment to see the full error message
    const cc_payments = [];
    // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'payment' implicitly has an 'any' type.
    payments.forEach(function(payment) {
      // Find payments that may require a signature.  For EMV payments (i.e. via a
      // terminal) the signature would have already been collected.
      if (
        payment.cc_charge_id &&
        typeof payment.cc_charge_id === 'object' &&
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'credit_card' does not exist on type 'Mer... Remove this comment to see the full error message
        !window.merchantos.register.credit_card.isEMV(payment)
      ) {
        cc_payments.push(payment);
      }
    });
    if (cc_payments.length > 0) {
      // @ts-expect-error ts-migrate(7005) FIXME: Variable 'cc_payments' implicitly has an 'any[]' t... Remove this comment to see the full error message
      window.StencilWebAPI.signatureCapture.sendSignatureData(cc_payments);
    }
  };

  // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
  this.isEMV = function(payment) {
    // refunds have a reference to the original payment which we need `to determine if it's
    // an EMV transaction
    let originalPayment = payment;
    if (payment && payment.ref_payment_uid && payment.ref_payment_uid.cc_charge_id) {
      originalPayment = payment.ref_payment_uid;
    }

    // if the payment is a CC charge with a communication key then we consider it
    // an EMV payment
    return (
      originalPayment.cc_charge_id &&
      typeof originalPayment.cc_charge_id === 'object' &&
      typeof originalPayment.cc_charge_id.communication_key === 'string' &&
      originalPayment.cc_charge_id.communication_key.length > 0
    );
  };
})();

// @ts-expect-error ts-migrate(2339) FIXME: Property 'notes' does not exist on type 'Merchanto... Remove this comment to see the full error message
window.merchantos.register.notes = new (function() {
  // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
  this.key_press_timer = 0;

  // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
  this.keyPressEditNote = function(input, transactionID) {
    if (this.key_press_timer) {
      clearTimeout(this.key_press_timer);
    }

    this.key_press_timer = setTimeout(function() {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'notes' does not exist on type 'Merchanto... Remove this comment to see the full error message
      window.merchantos.register.notes.updateNote(input, transactionID);
    }, 3000);

    return true;
  };

  // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
  this.updateNote = function(input, transactionID) {
    if (this.key_press_timer) {
      clearTimeout(this.key_press_timer);
      this.key_press_timer = 0;
    }

    const content_map = {} as ContentMap;
    content_map.form_name = 'register.inline_edit.update_sale_field';
    content_map.transaction_id = transactionID;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'field_name' does not exist on type 'Cont... Remove this comment to see the full error message
    content_map.field_name = input.name;
    content_map.fnc = 'save';
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'field_value' does not exist on type 'Con... Remove this comment to see the full error message
    content_map.field_value = window.getFormFieldValue(input);

    window.doServerCall(content_map);

    return true;
  };

  // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
  this.addUserSignature = function(_element, textarea) {
    const employee = window.merchantos.session.getEmployee();
    const date_format = `${window.merchantos.locale.date_format.toUpperCase()} HH:mm:ss`;
    // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
    let message = `${employee.firstName} ${employee.lastName} (${moment(Date.now()).format(
      date_format
    )})`;

    if ($(textarea).val()) {
      message = `\n${message}`;
    }

    $(textarea).val($(textarea).val() + message);
    setTimeout(function waitForTrigger() {
      $(textarea).trigger('change');
    }, 0);
  };

  // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
  this.hideSaleNotes = function(element, notesWrapper) {
    $(notesWrapper)
      .stop()
      .slideToggle('fast', function() {
        $(element).text($(element).text() === 'Hide Notes' ? 'Show Notes' : 'Hide Notes');
      });
  };
})();

// @ts-expect-error ts-migrate(2339) FIXME: Property 'charge_account' does not exist on type '... Remove this comment to see the full error message
window.merchantos.register.charge_account = new (function() {
  // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
  this.open = function() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
    window.merchantos.register.payments.init();

    // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
    if (window.moneycomp(Math.abs(window.merchantos.register.payments.getBalanceOwed()), '<=', 0)) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
      if (window.moneycomp(window.merchantos.register.payments.sale_total, '>=', 0))
        window.alertUser('There is no balance left to pay.');
      else window.alertUser('There is no balance left to refund.');
      return false;
    }

    const content_map = {} as ContentMap;

    // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
    if (window.moneycomp(window.merchantos.register.payments.sale_total, '>=', 0)) {
      content_map.form_name = 'register.payments.charge_account';
    } else {
      content_map.form_name = 'register.refunds.charge_account';
    }
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'sale_total' does not exist on type 'Cont... Remove this comment to see the full error message
    content_map.sale_total = window.merchantos.register.payments.sale_total;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'total_payments' does not exist on type '... Remove this comment to see the full error message
    content_map.total_payments = window.merchantos.register.payments.current_total;
    window.doServerCall(content_map, function(result) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'charge_account' does not exist on type '... Remove this comment to see the full error message
      window.merchantos.register.charge_account.onreturn(result);
    });
    return true;
  };

  // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
  this.close = function() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
    window.merchantos.register.payments.restoreContent();
  };

  // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
  this.addPayment = function(input, max) {
    input = window.singleElementById(input);
    if (!input || !input.value) return false;
    let amount = window.getMoney(input.value);
    if (max && window.moneycomp(amount, '>', max)) {
      window.alertUser(
        "There is not enough credit left in the customer's credit account to complete the charge."
      );
      input.value = window.formatMoney(max);
      return false;
    }

    this.close();

    // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
    window.merchantos.register.payments.init();
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
    if (window.moneycomp(window.merchantos.register.payments.sale_total, '<', 0)) {
      amount = Math.abs(amount) * -1.0;
    }

    // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
    window.merchantos.register.payments.credit_charge = amount;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
    if (!window.merchantos.register.payments.onChange()) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
      window.merchantos.register.payments.credit_charge = 0.0;
      return false;
    }

    const remove_btn =
      '<button onclick="window.merchantos.register.charge_account.removePayment(); return false;" class="gui-def-button">Remove</button>';
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
    window.merchantos.register.payments.addSpecialPaymentHTML(
      'charge_account_payment',
      'Credit Account',
      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'number' is not assignable to par... Remove this comment to see the full error message
      window.formatMoney(Math.abs(amount)),
      remove_btn
    );

    // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
    if (window.moneycomp(window.merchantos.register.payments.sale_total, '<', 0)) {
      window.flashNotifier(
        'success',
        `Credit Account Refund Of <var>${window.formatMoney(
          // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'number' is not assignable to par... Remove this comment to see the full error message
          Math.abs(amount)
        )}</var> Added.`,
        4
      );
    } else {
      window.flashNotifier(
        'success',
        `Credit Account Charge Of <var>${window.formatMoney(
          // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'number' is not assignable to par... Remove this comment to see the full error message
          Math.abs(amount)
        )}</var> Added.`,
        4
      );
    }

    return true;
  };

  // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
  this.removePayment = function() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
    window.merchantos.register.payments.removeSpecialPayment('charge_account_payment');
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
    window.merchantos.register.payments.credit_charge = 0.0;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
    window.merchantos.register.payments.onChange();
  };

  // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
  this.onreturn = function(result) {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
    if (result.html) window.merchantos.register.payments.replaceContent(result.html);
    if (result.focus) window.merchantos.focus.set(result.focus);
    if (result.cancel) this.close();
  };
})();

// @ts-expect-error ts-migrate(2339) FIXME: Property 'account_actions' does not exist on type ... Remove this comment to see the full error message
window.merchantos.register.account_actions = new (function() {
  // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
  this.deposit = function(alt_title) {
    window.merchantos.register.ensureAppIsDefined();
    window.App.channel.vent.trigger(
      window.App.globalEvents.register.ADD_DEPOSIT,
      !_.isUndefined(alt_title)
    );
    return true;
  };

  // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
  this.withdraw = function() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
    window.merchantos.register.payments.init();

    const content_map = {} as ContentMap;
    content_map.form_name = 'register.account_actions.withdraw';
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'credit_account_payment' does not exist o... Remove this comment to see the full error message
    content_map.credit_account_payment = window.merchantos.register.payments.credit_charge;
    window.merchantos.register.ensureAppIsDefined();
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'current_withdraws' does not exist on typ... Remove this comment to see the full error message
    content_map.current_withdraws = window.toJsonString(
      window.App.channel.reqres.request(window.App.globalEvents.register.DEPOSIT_REFUNDS_REQUESTED)
    );
    window.doServerCall(content_map, function(result) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'account_actions' does not exist on type ... Remove this comment to see the full error message
      window.merchantos.register.account_actions.onreturn(result);
    });
    return true;
  };

  // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
  this.close = function() {
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    window.singleElementById('account_actions').innerHTML = '';
  };

  // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
  this.addDeposit = function(input, _title, payment_type, _emvEnabled, _saleID) {
    input = window.singleElementById(input);
    if (!input || !input.value) return false;
    const amount = window.getMoney(input.value);

    if (window.moneycomp(amount, '<=', 0)) {
      return false;
    }

    const payment_type_selector = window.singleElementById(payment_type);

    this.close();

    if (payment_type_selector) {
      window.merchantos.register.ensureAppIsDefined();
      window.App.channel.vent.trigger(
        window.App.globalEvents.register.ADD_DEPOSIT,
        amount,
        payment_type_selector.value
      );
    }

    return true;
  };

  // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
  this.addWithdraw = function(input_amount, select_type, max) {
    input_amount = window.singleElementById(input_amount);
    select_type = window.singleElementById(select_type);
    if (!input_amount || !input_amount.value || !select_type) return false;
    const amount = window.getMoney(input_amount.value);

    if (window.moneycomp(amount, '<=', 0)) {
      window.alertUser('You must enter a deposit refund amount.');
      window.merchantos.focus.set(input_amount);
      return false;
    }

    if (window.moneycomp(max, '<', amount)) {
      window.alertUser(
        "There is not enough credit left in the customer's credit account to complete the deposit refund."
      );
      return false;
    }

    let type = window.getFormFieldValue(select_type);

    let type_description = select_type.options[select_type.selectedIndex].innerHTML;
    let cardNumber = null;

    // @ts-expect-error ts-migrate(2349) FIXME: This expression is not callable.
    if (type.indexOf('credit_card.') != -1) {
      // @ts-expect-error ts-migrate(2349) FIXME: This expression is not callable.
      const type_parts = type.split('.');
      if (type_parts.length == 4) {
        type_parts[2] = parseFloat(`${type_parts[2]}.${type_parts[3]}`);
      }
      if (window.moneycomp(type_parts[2], '<', amount)) {
        window.alertUser(
          `The credit card charge you have chosen to refund can only be refunded for ${window.formatMoney(
            type_parts[2]
          )}.`
        );
        return false;
      }
      type = `${type_parts[0]}.${type_parts[1]}`;
      type_description = type_description.split(' (')[0];

      // type_description is something like "Visa 1001" or "American Express 2114".
      // We want to pull only the number part.
      const splitTypeDescription = type_description.split(' ');
      cardNumber = splitTypeDescription[splitTypeDescription.length - 1];

      // Sanitize the input to make sure we're getting a number
      cardNumber = isNaN(parseInt(cardNumber)) ? null : cardNumber;
    }

    this.close();

    if (type) {
      let originalPaymentID = 0;
      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string | { [key: string]: string... Remove this comment to see the full error message
      let paymentTypeID = parseInt(type);

      // @ts-expect-error ts-migrate(2349) FIXME: This expression is not callable.
      if (type.indexOf('credit_card.') != -1) {
        // @ts-expect-error ts-migrate(2349) FIXME: This expression is not callable.
        originalPaymentID = parseInt(type.split('.')[1]);
        paymentTypeID = 0;
      }

      window.merchantos.register.ensureAppIsDefined();
      window.App.channel.vent.trigger(window.App.globalEvents.register.ADD_DEPOSIT_REFUND, amount, {
        cardNumber,
        paymentTypeID,
        originalPaymentID,
        cardType: $(select_type)
          .find(':selected')
          .attr('data-cardtype'),
        paymentID: $(select_type)
          .find(':selected')
          .attr('data-paymentid'),
      });
    }

    return true;
  };

  // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
  this.removeDeposit = function() {
    this.close();

    const account_deposit_row = window.singleElementById('account_deposit_row');
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    account_deposit_row.style.display = 'none';

    const account_deposit_cell = window.singleElementById('account_deposit_cell');
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    account_deposit_cell.innerHTML = '';

    // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
    window.merchantos.register.payments.init();
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
    window.merchantos.register.payments.sale_total -=
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
      window.merchantos.register.payments.credit_deposit;

    // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
    const payment_type_id = window.merchantos.register.payments.credit_deposit_type;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
    const deposit_amount = window.merchantos.register.payments.credit_deposit;
    if (deposit_amount > 0 && payment_type_id) {
      let payment_id;
      if (payment_type_id == 'gift_card') {
        // see if there's a gift card payment that exactly matches deposit_amount
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
        for (payment_id in window.merchantos.register.payments.gift_cards) {
          if (
            window.moneycomp(
              // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
              window.merchantos.register.payments.gift_cards[payment_id],
              '==',
              deposit_amount
            )
          ) {
            // @ts-expect-error ts-migrate(2339) FIXME: Property 'gift_card' does not exist on type 'Merch... Remove this comment to see the full error message
            window.merchantos.register.gift_card.removePayment(payment_id);
          }
        }
      } else if (payment_type_id == 'credit_card') {
        // see if there's a credit card payment that exactly matches deposit_amount
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
        for (payment_id in window.merchantos.register.payments.credit_cards) {
          if (
            window.moneycomp(
              // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
              window.merchantos.register.payments.credit_cards[payment_id].amount,
              '==',
              deposit_amount
            )
          ) {
            // @ts-expect-error ts-migrate(2339) FIXME: Property 'credit_card' does not exist on type 'Mer... Remove this comment to see the full error message
            window.merchantos.register.credit_card.removePayment(payment_id);
          }
        }
      } else {
        // try to remove the deposit from the payment type it was made under
        const payment_field = window.singleElementById(payment_type_id);
        if (payment_field && window.moneycomp(deposit_amount, '!=', 0))
          if (payment_field && window.moneycomp(deposit_amount, '!=', 0)) {
            const current_value = window.getMoney(payment_field.value);
            if (window.moneycomp(current_value, '==', deposit_amount)) {
              payment_field.value = '$0.00';
              // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
              window.merchantos.register.payments.onChange(payment_field);
            }
          }
      }
    }

    // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
    window.merchantos.register.payments.credit_deposit = 0.0;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
    window.merchantos.register.payments.credit_deposit_type = 0;

    const credit_account_payment_rows = window.singleElementById('credit_account_payment_rows');
    if (credit_account_payment_rows) {
      credit_account_payment_rows.style.display = '';
    }

    // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
    window.merchantos.register.payments.onChange();
  };

  // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
  this.removeWithdraw = function(type) {
    let total_withdraws = 0;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
    for (const id in window.merchantos.register.payments.credit_withdraws) {
      if (id == type) {
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
        delete window.merchantos.register.payments.credit_withdraws[id];
        continue;
      }
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
      total_withdraws += Number(window.merchantos.register.payments.credit_withdraws[id].amount);
    }

    if (total_withdraws <= 0) {
      const account_withdraw_row = window.singleElementById('account_withdraw_row');
      if (account_withdraw_row) {
        account_withdraw_row.style.display = 'none';
      }

      const account_withdraw_cell = window.singleElementById('account_withdraw_cell');
      if (account_withdraw_cell) {
        account_withdraw_cell.innerHTML = '';
      }
    }

    // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
    window.merchantos.register.payments.removeSpecialPayment(`credit_withdraw_${type}`);
  };

  // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
  this.onreturn = function(result) {
    if (result.html) {
      const account_actions = window.singleElementById('account_actions');
      if (account_actions) {
        account_actions.innerHTML = result.html;
      }
    }
    if (result.focus) window.merchantos.focus.set(result.focus);
    if (result.cancel) this.close();
  };
})();

// @ts-expect-error ts-migrate(2339) FIXME: Property 'partial_payments' does not exist on type... Remove this comment to see the full error message
window.merchantos.register.partial_payments = {
  /**
   * Initialize an EMV payment and, on a successful payment, add the payment
   * to the sale
   *
   * @param gatewayID {Number} The ID of the gateway
   * @param transactionID {Number} The ID of the gateway
   */
  // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'gatewayID' implicitly has an 'any' type... Remove this comment to see the full error message
  startPayment(gatewayID, transactionID) {
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    const amount = window.singleElementById('credit_card_amount').value;

    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    const name = window.singleElementById('terminal_select').value;

    let provider;

    window.showNotifier('working');
    this.waitForPayment();

    // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
    const shopID = window.merchantos.session.getShop().shopID;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
    window.merchantos.payments
      .getTerminal(name, shopID)
      // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'terminal' implicitly has an 'any' type.
      .done(function(terminal) {
        // If we don't already have a provider for this terminal stored,
        // instantiate a new one
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
        provider = window.merchantos.payments.getProvider(terminal.name, shopID);
        if (!provider) {
          // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
          provider = window.merchantos.payments.addProvider(
            'Genius',
            terminal.name,
            shopID,
            gatewayID,
            terminal
          );
        }

        // store the provider for later cancellation
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'partial_payments' does not exist on type... Remove this comment to see the full error message
        window.merchantos.register.partial_payments._provider = provider;

        provider.start(transactionID);
        provider.addPayment(amount);
        provider
          .processPayment()
          // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
          .done(function(response) {
            const payment = response.SalePayment;
            // @ts-expect-error ts-migrate(2339) FIXME: Property 'partial_payments' does not exist on type... Remove this comment to see the full error message
            window.merchantos.register.partial_payments.addPayment(
              payment.saleID,
              payment.salePaymentID
            );
            // @ts-expect-error ts-migrate(2339) FIXME: Property 'credit_card' does not exist on type 'Mer... Remove this comment to see the full error message
            window.merchantos.register.credit_card.close();
          })
          // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
          .fail(function(response) {
            // @ts-expect-error ts-migrate(2339) FIXME: Property 'partial_payments' does not exist on type... Remove this comment to see the full error message
            window.merchantos.register.partial_payments.processFailed(response);
          })
          .always(function() {
            // operation is complete so clear the provider
            // @ts-expect-error ts-migrate(2339) FIXME: Property 'partial_payments' does not exist on type... Remove this comment to see the full error message
            window.merchantos.register.partial_payments._provider = null;
            // @ts-expect-error ts-migrate(2339) FIXME: Property 'partial_payments' does not exist on type... Remove this comment to see the full error message
            window.merchantos.register.partial_payments.dismissProcessingModal();
          });
      })
      .fail(function() {
        const message = 'Could not get terminal details';
        window.hideNotifier('working');
        window.flashNotifier('warning', message, 5);
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'partial_payments' does not exist on type... Remove this comment to see the full error message
        window.merchantos.register.partial_payments.reject(message);
      });
  },

  /**
   * Retrieves the specified payment using the API and adds it the register view.
   *
   * @param saleID {string} The ID of the sale
   * @param * {number|object} Either the salePaymentID or an object containing
   *                          payment information.
   *
   * @return {jQuery.promise}
   */
  // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'saleID' implicitly has an 'any' type.
  addPayment(saleID) {
    const args = Array.prototype.slice.call(arguments);
    const deferred = $.Deferred();

    // this method expects either a salePaymentID or a hash containing payment
    // information.  If only one parameter is passed reject the payment.
    if (args.length > 1) {
      if (_.isObject(args[1])) {
        // A hash was passed for the second argument so expect that the data is
        // for a terminal without server-side gateway support.  Just add the
        // payment using the information provided.
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'amount' does not exist on type 'object'.
        if (args[1].amount && args[1].paymentTypeID && args[1].transactionReferenceID) {
          const payment = {
            saleID,
            // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
            registerID: window.merchantos.session.getRegister().registerID,
            // @ts-expect-error ts-migrate(2339) FIXME: Property 'paymentTypeID' does not exist on type 'o... Remove this comment to see the full error message
            paymentTypeID: args[1].paymentTypeID,
            // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
            employeeID: window.merchantos.session.getEmployee().employeeID,
            // @ts-expect-error ts-migrate(2339) FIXME: Property 'amount' does not exist on type 'object'.
            amount: args[1].amount,
            // @ts-expect-error ts-migrate(2339) FIXME: Property 'transactionReferenceID' does not exist o... Remove this comment to see the full error message
            transactionReferenceID: args[1].transactionReferenceID,
          };

          if (payment.amount < 0) {
            // for refunds, make sure we're in the correct view
            // @ts-expect-error ts-migrate(2339) FIXME: Property 'credit_card' does not exist on type 'Mer... Remove this comment to see the full error message
            window.merchantos.register.credit_card.close();
          }
          // @ts-expect-error ts-migrate(2339) FIXME: Property 'credit_card' does not exist on type 'Mer... Remove this comment to see the full error message
          window.merchantos.register.credit_card.addEmvPayment(payment);
          deferred.resolve();
        } else {
          deferred.reject('Invalid payment information.');
        }
      } else {
        // We're expecting that the second parameter is a salePaymentID
        const URL = `/API/Account/${window.merchantos.session.getSystemCustomerID()}/SalePayment/${
          args[1]
        }.json?load_relations=["CCCharge"]&readonly=0`;

        window.showNotifier('working');

        $.ajax({
          url: URL,
          type: 'GET',
          contentType: 'application/json; charset=utf-8',
          dataType: 'json',
        })
          .done(function(response) {
            let payment = null;
            if (response && response.SalePayment) {
              payment = response.SalePayment;
            } else if (
              response &&
              response.Sale &&
              response.Sale.SalePayments &&
              response.Sale.SalePayments.SalePayment
            ) {
              payment = response.Sale.SalePayments.SalePayment;

              if (_.isArray(payment)) {
                // Until we have an API-based payment system we have
                // to assume the last payment is the new one.
                payment = payment[payment.length - 1];
              }
            }

            if (payment) {
              if (payment.saleID !== saleID) {
                deferred.reject('Received payment is not for the current sale.');
              } else {
                if (payment.amount < 0) {
                  // for refunds, make sure we're in the correct view
                  // @ts-expect-error ts-migrate(2339) FIXME: Property 'credit_card' does not exist on type 'Mer... Remove this comment to see the full error message
                  window.merchantos.register.credit_card.close();
                }
                // @ts-expect-error ts-migrate(2339) FIXME: Property 'credit_card' does not exist on type 'Mer... Remove this comment to see the full error message
                window.merchantos.register.credit_card.addEmvPayment(payment);
                deferred.resolve();
              }
            } else {
              deferred.reject('Payment not added to the sale.');
            }
          })
          .fail(function(response) {
            console.error('Failed to retrieve the payment:', response);
            deferred.reject(response);
          })
          .always(function() {
            window.hideNotifier('working');
          });

        deferred.fail(function(error) {
          window.flashNotifier('warning', error, 5);
        });
      }
    } else {
      deferred.reject('Payment not added.  Invalid sale data.');
    }

    return deferred.promise();
  },

  /**
   * Voids a partial payment in the sale via the API.
   *
   * @param saleID {string} The ID of the sale
   * @param paymentID {string} The ID of the payment to be voided
   *
   * @private
   */
  // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'saleID' implicitly has an 'any' type.
  voidTransaction(saleID, paymentID) {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'partial_payments' does not exist on type... Remove this comment to see the full error message
    const paymentData = window.merchantos.register.partial_payments._buildPaymentData({
      salePaymentID: paymentID,
      archived: true,
    });

    window.showNotifier('working');

    const URL = `/API/Account/${window.merchantos.session.getSystemCustomerID()}/Sale/${saleID}.json?load_relations=all`;

    const $deferred = $.Deferred();
    $.ajax({
      url: URL,
      type: 'PUT',
      data: JSON.stringify(paymentData),
      contentType: 'application/json; charset=utf-8',
      dataType: 'json',
    })
      .done(function() {
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'credit_card' does not exist on type 'Mer... Remove this comment to see the full error message
        window.merchantos.register.credit_card.removeEmvPayment(paymentID);
      })
      .fail(function(response) {
        console.error('Failed to void the transaction:', response);
        $deferred.reject(response);
      })
      .always(function() {
        window.hideNotifier('working');
      });

    $deferred.fail(function(error) {
      window.flashNotifier('warning', error, 5);
    });
  },

  /**
   * Voids a partial payment that requires a reference but has no server-side support.  This
   * is currently only utilized for iZettle payments.  Since the transaction ID is not stored
   * on the server, if the payments view is dismissed all reference to the transaction (as
   * far as webPOS is concerned) is lost.
   *
   * @param saleID {string}   The ID of the sale
   * @param transactionReferenceID {string}   The transaction ID to identify the payment
   * @param amount {string}   The amount to be refunded
   */
  // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'saleID' implicitly has an 'any' type.
  voidTransactionByReference(saleID, transactionReferenceID, amount) {
    if (saleID && transactionReferenceID) {
      // @ts-expect-error ts-migrate(2554) FIXME: Expected 5 arguments, but got 4.
      window.StencilWebAPI.cardReader.initiatePaymentTerminalRefund(
        saleID,
        transactionReferenceID,
        amount,
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
        window.merchantos.register.payments.getBalanceOwed().toString()
      );
    }
  },

  /**
   * In the case of a payment that was approved with errors, adds the payment
   * to the payments list
   */
  acceptLastPayment() {
    this.addPayment(this.lastPayment.saleID, this.lastPayment.salePaymentID);
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'credit_card' does not exist on type 'Mer... Remove this comment to see the full error message
    window.merchantos.register.credit_card.close();
  },

  /**
   * Voids the most recent payment; is used when a payment is approved with errors
   */
  voidLastPayment() {
    this.voidTransaction(this.lastPayment.saleID, this.lastPayment.salePaymentID);
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'credit_card' does not exist on type 'Mer... Remove this comment to see the full error message
    window.merchantos.register.credit_card.close();
  },

  /**
   * Refreshes the total presented in the payment block with a total of current partial payments
   * in the block.
   */
  refreshTotal() {
    // if partial payments already exist in the sale, we need to add the existing payments
    // and update the totals since this all happens in JavaScript
    const $emvPayments = $('#emv_payments_list');
    if ($emvPayments.length) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
      window.merchantos.register.payments.init();
      $emvPayments.find('tr').each(function(_index, payment) {
        const $payment = $(payment);
        const amount = window.getMoney($payment.find('.payment-amount').text());
        const salePaymentID = $payment.attr('payment_id');
        const paymentTypeID = $payment.attr('payment_type_id');
        const ccChargeID = $payment.attr('cc_charge_id');
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'credit_card' does not exist on type 'Mer... Remove this comment to see the full error message
        window.merchantos.register.credit_card.addEmvPaymentToPaymentsList({
          amount,
          salePaymentID,
          paymentTypeID,
          ccChargeID,
        });
      });
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
      window.merchantos.register.payments.onChange();
    }
  },

  /**
   * Displays while the payment is being processed by the terminal
   */
  waitForPayment() {
    $('#emv-payment-start').hide();
    $('#payment-options').hide();
    $('#emv-error').hide();
    $('#emv-payment-waiting').show();

    // @ts-expect-error ts-migrate(2339) FIXME: Property 'partial_payments' does not exist on type... Remove this comment to see the full error message
    window.merchantos.register.partial_payments.showProcessingModal();
  },

  /**
   * Displays a modal while the terminal transaction is in progress.  While this modal is displayed
   * navigation away from the page (reload or closing tab/browser) will result in a pop-up alert for
   * confirmation.
   */
  showProcessingModal() {
    const overlay = $('<div class="modal-overlay animate-in"></div>');
    const container = $('<div class="modal-container animate-in"></div>');
    const title = $(
      `<div class="modal-header"><h1>${
        $('#terminal_select').val() ? `<var>${$('#terminal_select').val()}</var>` : 'Terminal'
      } - Transaction in progress.</h1></div>`
    );
    const content = $('<div class="modal-content"></div>');
    const modalPage = $('<div class="modal-page"></div>');
    const message = $('<div class="modal-message">Waiting for payment...</div>');
    const cancelButton = $(
      '<div class="modal-button-container"><div class="modal-button">Cancel Payment</div></div>'
    );

    modalPage.append(message).append(cancelButton);
    content.append(modalPage);
    container.append(title).append(content);
    container.appendTo(overlay);
    overlay.appendTo('body');

    cancelButton.on('click', function() {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'partial_payments' does not exist on type... Remove this comment to see the full error message
      window.merchantos.register.partial_payments.cancel($(this).find('.modal-button'));
    });

    $(window).on('beforeunload.processing-payment', function() {
      return (
        'A transaction is in progress on the Payment Terminal.\n' +
        'Please cancel it before leaving this screen.'
      );
    });
  },

  /**
   * Dismisses the transaction modal.
   */
  dismissProcessingModal() {
    const overlay = $('.modal-overlay');
    const container = overlay.find('.modal-container');

    overlay.one('animationend webkitAnimationEnd', function() {
      overlay.remove();
    });

    container.removeClass('animate-in').addClass('animate-out');
    overlay.removeClass('animate-in').addClass('animate-out');
    $(window).off('.processing-payment');
  },

  /**
   * Displays the appropriate error if a payment fails
   *
   * @param message {String} A short description of the error that occurred
   * @param cayanError {String} Cayan-provided error message
   */
  // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'message' implicitly has an 'any' type.
  reject(message, cayanError, showPrintButton) {
    const $error = $('#emv-error');
    $error.find('h1').text(message);
    $error.find('p').text(cayanError);
    $error.find('#emv_print_failed_receipt').toggle(showPrintButton);
    $error.show();
    $('#emv-payment-waiting').hide();
  },

  /**
   * Displays the approved-with-errors block and stores the sale payment
   *
   * @param response {Object} Contains the SalePayment data and the error
   */
  // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
  approveError(response) {
    const $approveError = $('#emv-approve-error');
    $approveError.find('.error-explanation').text(response.errorMessage);
    $('#emv-payment-waiting').hide();
    $approveError.show();

    this.lastPayment = response.SalePayment;
  },

  /**
   * Called when processing the sale via the terminal failed for some reason
   *
   * @param response {Object} Response from the terminal provider with failure
   *                          information stored
   */
  // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
  processFailed(response) {
    let message;

    let cayanError = '';
    switch (response.status) {
      case 'UserCancelled':
        message = 'User cancelled payment';
        break;
      case 'DECLINED':
        message = 'Payment was declined';
        break;
      case 'approvedError':
        message = 'Payment was approved with errors';
        break;
      case 'POSCancelled':
        message = 'Transaction was cancelled';
        break;
      default:
        message = 'Could not process payment';
        cayanError = response.error || '';
    }

    window.hideNotifier('working');

    this.lastPayment = {
      ccChargeID: response.ccChargeID,
    };

    if (response.status === 'approvedError') {
      this.approveError(response);
    } else {
      const showPrintButton =
        response.status !== 'POSCancelled' &&
        response.status !== 'UserCancelled' &&
        response.status !== 'FAILED' &&
        !_.isUndefined(response.ccChargeID) &&
        !_.isNull(response.ccChargeID);
      this.reject(message, cayanError, showPrintButton);
    }
  },

  /**
   * POS cancels an EMV payment once it's already been started; can potentially
   * fail if a payment is approved before the function call completes
   */
  // @ts-expect-error ts-migrate(7006) FIXME: Parameter '$cancelButton' implicitly has an 'any' ... Remove this comment to see the full error message
  cancel($cancelButton) {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'partial_payments' does not exist on type... Remove this comment to see the full error message
    const provider = window.merchantos.register.partial_payments._provider;
    if (provider && $cancelButton && $cancelButton.length) {
      $cancelButton.prop('disabled', true);
      const currentButtonText = $cancelButton.text();
      $cancelButton.text('Cancelling...');
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'partial_payments' does not exist on type... Remove this comment to see the full error message
      window.merchantos.register.partial_payments
        .forceCancel()
        .fail(function() {
          window.flashNotifier('warning', 'Cannot cancel the transaction at this time', 5);
        })
        .always(function() {
          $cancelButton.prop('disabled', false);
          $cancelButton.text(currentButtonText);
        });
    } else {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'credit_card' does not exist on type 'Mer... Remove this comment to see the full error message
      window.merchantos.register.credit_card.close();
    }

    window.hideNotifier('working');
  },

  printFailedReceipt() {
    const ccChargeID = this.lastPayment.ccChargeID;
    let url = `/API/Account/${window.merchantos.session.getSystemCustomerID()}`;
    url += `/DisplayTemplate/CCCharge/${ccChargeID}`;
    url += '.html?template=CCCharge&print=1';

    window.merchantos.print.printUrl({ url, pageType: 'receipt' });
  },

  /**
   * Forces a cancel against the terminal with retries.  It will retry up to 5 times
   * (once every two seconds).  If it fails after the 5th time it will give up and
   * reject the promise.
   *
   * @returns {jQuery.promise}
   */
  forceCancel() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'partial_payments' does not exist on type... Remove this comment to see the full error message
    const provider = window.merchantos.register.partial_payments._provider;
    const deferred = $.Deferred();
    const retries = 5;

    if (provider) {
      let retryAttempt = 0;

      provider
        .cancelTransaction()
        // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
        .done(function(response) {
          if (response.Status === 'Cancelled') {
            deferred.resolve();
          } else {
            retryAttempt++;
            if (retryAttempt <= retries) {
              // retry after a second
              setTimeout(
                function() {
                  // $.ajax will retry with this (jqXHR) because it contains
                  // all the options of the original request.  However,
                  // we need to resolveWith() the existing parameters to preserve
                  // the callbacks for another iteration.  This has the effect
                  // of entirely re-using the original jqXHR and its callbacks.
                  // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
                  $.ajax(this)
                    .done(function(data, textStatus, jqXHR) {
                      // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
                      deferred.resolveWith(this, [data, textStatus, jqXHR]);
                    })
                    .fail(function(jqXHR, textStatus, errorThrown) {
                      // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
                      deferred.rejectWith(this, [jqXHR, textStatus, errorThrown]);
                    });
                  // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
                }.bind(this),
                2000
              );
            } else {
              deferred.reject();
            }
          }
        })
        .fail(function() {
          deferred.reject();
        });
    } else {
      deferred.reject();
    }

    return deferred.promise();
  },

  /**
   * Retrieves an object of the appropriate format for transmitting a sale payment
   * via the API.
   *
   * @param salePayment {object} An object containing attributes for a SalePayment.
   * @returns {object} An object of the appropriate format to be transmitted to
   *                   update a payment in a sale.
   * @private
   */
  // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'salePayment' implicitly has an 'any' ty... Remove this comment to see the full error message
  _buildPaymentData(salePayment) {
    return {
      // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
      shopID: window.merchantos.session.getShop().shopID,
      // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
      registerID: window.merchantos.session.getRegister().registerID,
      SalePayments: {
        SalePayment: [salePayment],
      },
    };
  },
};

$('#add_search_item_text').on('focus', function(event) {
  /*
   * Field is occasionally recieiving input in the middle of a scanner input,
   * which then highlights and overwrites part of the input.
   * Trigger a right arrow keypress to un-highlight input without changing it.
   */
  const e = $.Event('keypress');
  e.which = 39;
  $(event.target).trigger(e);
});
